var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a2, b2) => {
  for (var prop in b2 || (b2 = {}))
    if (__hasOwnProp.call(b2, prop))
      __defNormalProp(a2, prop, b2[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b2)) {
      if (__propIsEnum.call(b2, prop))
        __defNormalProp(a2, prop, b2[prop]);
    }
  return a2;
};
var __spreadProps = (a2, b2) => __defProps(a2, __getOwnPropDescs(b2));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e2) {
        reject(e2);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e2) {
        reject(e2);
      }
    };
    var step = (x2) => x2.done ? resolve(x2.value) : Promise.resolve(x2.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import L$2, { TileLayer, LatLngBounds, DivIcon, Marker, Polyline, Polygon, LatLng } from "@tuliu/leaflet";
function styleInject(css2, ref) {
  if (ref === void 0)
    ref = {};
  var insertAt = ref.insertAt;
  if (!css2 || typeof document === "undefined") {
    return;
  }
  var head = document.head || document.getElementsByTagName("head")[0];
  var style = document.createElement("style");
  style.type = "text/css";
  if (insertAt === "top") {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }
  if (style.styleSheet) {
    style.styleSheet.cssText = css2;
  } else {
    style.appendChild(document.createTextNode(css2));
  }
}
var css$1 = '.leaflet-vertex-icon,\n.leaflet-middle-icon {\n  background-color: transparent;\n  border-radius: 50%;\n  border: 0;\n}\n.leaflet-vertex-icon::after,\n.leaflet-middle-icon::after {\n  content: " ";\n  width: 10px;\n  height: 10px;\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  background-color: #fff;\n  border-radius: 50%;\n}\n\n.leaflet-middle-icon::after {\n  opacity: 0.5;\n}\n\n.leaflet-middle-icon-length {\n  color: #fff;\n  font-size: 14px;\n  position: relative;\n  right: -25px;\n  pointer-events: none;\n}\n\n.leaflet-thumb-icon {\n  background-color: red;\n  border-radius: 50%;\n}\n\n.leaflet-title-icon {\n  color: #fff;\n}\n\n.leaflet-control-attribution.leaflet-control {\n  display: none !important;\n}';
var ZoomLimit;
(function(ZoomLimit2) {
  ZoomLimit2[ZoomLimit2["Max"] = 20] = "Max";
  ZoomLimit2[ZoomLimit2["Min"] = 3] = "Min";
})(ZoomLimit || (ZoomLimit = {}));
var LayerType;
(function(LayerType2) {
  LayerType2[LayerType2["defaultSatellite"] = 0] = "defaultSatellite";
  LayerType2[LayerType2["defaultVector"] = 1] = "defaultVector";
})(LayerType || (LayerType = {}));
const ICON_SIZE = [28, 28];
L$2.Editable = L$2.Evented.extend({
  statics: {
    FORWARD: 1,
    BACKWARD: -1
  },
  options: {
    zIndex: 1e3,
    polygonClass: L$2.Polygon,
    polylineClass: L$2.Polyline,
    markerClass: L$2.Marker,
    rectangleClass: L$2.Rectangle,
    circleClass: L$2.Circle,
    drawingCSSClass: "leaflet-editable-drawing",
    drawingCursor: "crosshair",
    editLayer: void 0,
    featuresLayer: void 0,
    polylineEditorClass: void 0,
    polygonEditorClass: void 0,
    markerEditorClass: void 0,
    rectangleEditorClass: void 0,
    circleEditorClass: void 0,
    lineGuideOptions: {},
    skipMiddleMarkers: false
  },
  initialize: function(map, options) {
    L$2.setOptions(this, options);
    this._lastZIndex = this.options.zIndex;
    this.map = map;
    this.editLayer = this.createEditLayer();
    this.featuresLayer = this.createFeaturesLayer();
    this.forwardLineGuide = this.createLineGuide();
    this.backwardLineGuide = this.createLineGuide();
  },
  fireAndForward: function(type, e2) {
    e2 = e2 || {};
    e2.editTools = this;
    this.fire(type, e2);
    this.map.fire(type, e2);
  },
  createLineGuide: function() {
    var options = L$2.extend({ dashArray: "5,10", weight: 1, interactive: false }, this.options.lineGuideOptions);
    return L$2.polyline([], options);
  },
  createVertexIcon: function(options) {
    return L$2.Browser.mobile && L$2.Browser.touch ? new L$2.Editable.TouchVertexIcon(options) : new L$2.Editable.VertexIcon(options);
  },
  createEditLayer: function() {
    return this.options.editLayer || new L$2.LayerGroup().addTo(this.map);
  },
  createFeaturesLayer: function() {
    return this.options.featuresLayer || new L$2.LayerGroup().addTo(this.map);
  },
  moveForwardLineGuide: function(latlng) {
    if (this.forwardLineGuide._latlngs.length) {
      this.forwardLineGuide._latlngs[1] = latlng;
      this.forwardLineGuide._bounds.extend(latlng);
      this.forwardLineGuide.redraw();
    }
  },
  moveBackwardLineGuide: function(latlng) {
    if (this.backwardLineGuide._latlngs.length) {
      this.backwardLineGuide._latlngs[1] = latlng;
      this.backwardLineGuide._bounds.extend(latlng);
      this.backwardLineGuide.redraw();
    }
  },
  anchorForwardLineGuide: function(latlng) {
    this.forwardLineGuide._latlngs[0] = latlng;
    this.forwardLineGuide._bounds.extend(latlng);
    this.forwardLineGuide.redraw();
  },
  anchorBackwardLineGuide: function(latlng) {
    this.backwardLineGuide._latlngs[0] = latlng;
    this.backwardLineGuide._bounds.extend(latlng);
    this.backwardLineGuide.redraw();
  },
  attachForwardLineGuide: function() {
    this.editLayer.addLayer(this.forwardLineGuide);
  },
  attachBackwardLineGuide: function() {
    this.editLayer.addLayer(this.backwardLineGuide);
  },
  detachForwardLineGuide: function() {
    this.forwardLineGuide.setLatLngs([]);
    this.editLayer.removeLayer(this.forwardLineGuide);
  },
  detachBackwardLineGuide: function() {
    this.backwardLineGuide.setLatLngs([]);
    this.editLayer.removeLayer(this.backwardLineGuide);
  },
  blockEvents: function() {
    if (!this._oldTargets) {
      this._oldTargets = this.map._targets;
      this.map._targets = {};
    }
  },
  unblockEvents: function() {
    if (this._oldTargets) {
      this.map._targets = L$2.extend(this.map._targets, this._oldTargets);
      delete this._oldTargets;
    }
  },
  registerForDrawing: function(editor) {
    if (this._drawingEditor)
      this.unregisterForDrawing(this._drawingEditor);
    this.blockEvents();
    editor.reset();
    this._drawingEditor = editor;
    this.map.on("mousemove touchmove", editor.onDrawingMouseMove, editor);
    this.map.on("mousedown", this.onMousedown, this);
    this.map.on("mouseup", this.onMouseup, this);
    L$2.DomUtil.addClass(this.map._container, this.options.drawingCSSClass);
    this.defaultMapCursor = this.map._container.style.cursor;
    this.map._container.style.cursor = this.options.drawingCursor;
  },
  unregisterForDrawing: function(editor) {
    this.unblockEvents();
    L$2.DomUtil.removeClass(this.map._container, this.options.drawingCSSClass);
    this.map._container.style.cursor = this.defaultMapCursor;
    editor = editor || this._drawingEditor;
    if (!editor)
      return;
    this.map.off("mousemove touchmove", editor.onDrawingMouseMove, editor);
    this.map.off("mousedown", this.onMousedown, this);
    this.map.off("mouseup", this.onMouseup, this);
    if (editor !== this._drawingEditor)
      return;
    delete this._drawingEditor;
    if (editor._drawing)
      editor.cancelDrawing();
  },
  onMousedown: function(e2) {
    if (e2.originalEvent.which != 1)
      return;
    this._mouseDown = e2;
    this._drawingEditor.onDrawingMouseDown(e2);
  },
  onMouseup: function(e2) {
    if (this._mouseDown) {
      var editor = this._drawingEditor, mouseDown = this._mouseDown;
      this._mouseDown = null;
      editor.onDrawingMouseUp(e2);
      if (this._drawingEditor !== editor)
        return;
      var origin = L$2.point(mouseDown.originalEvent.clientX, mouseDown.originalEvent.clientY);
      var distance2 = L$2.point(e2.originalEvent.clientX, e2.originalEvent.clientY).distanceTo(origin);
      if (Math.abs(distance2) < 9 * (window.devicePixelRatio || 1))
        this._drawingEditor.onDrawingClick(e2);
    }
  },
  drawing: function() {
    return this._drawingEditor && this._drawingEditor.drawing();
  },
  stopDrawing: function() {
    this.unregisterForDrawing();
  },
  commitDrawing: function(e2) {
    if (!this._drawingEditor)
      return;
    this._drawingEditor.commitDrawing(e2);
  },
  connectCreatedToMap: function(layer) {
    return this.featuresLayer.addLayer(layer);
  },
  startPolyline: function(latlng, options) {
    var line = this.createPolyline([], options);
    line.enableEdit(this.map).newShape(latlng);
    return line;
  },
  startPolygon: function(latlng, options) {
    var polygon = this.createPolygon([], options);
    polygon.enableEdit(this.map).newShape(latlng);
    return polygon;
  },
  startMarker: function(latlng, options) {
    latlng = latlng || this.map.getCenter().clone();
    var marker = this.createMarker(latlng, options);
    marker.enableEdit(this.map).startDrawing();
    return marker;
  },
  startRectangle: function(latlng, options) {
    var corner = latlng || L$2.latLng([0, 0]);
    var bounds = new L$2.LatLngBounds(corner, corner);
    var rectangle = this.createRectangle(bounds, options);
    rectangle.enableEdit(this.map).startDrawing();
    return rectangle;
  },
  startCircle: function(latlng, options) {
    latlng = latlng || this.map.getCenter().clone();
    var circle = this.createCircle(latlng, options);
    circle.enableEdit(this.map).startDrawing();
    return circle;
  },
  startHole: function(editor, latlng) {
    editor.newHole(latlng);
  },
  createLayer: function(klass, latlngs, options) {
    options = L$2.Util.extend({ editOptions: { editTools: this } }, options);
    var layer = new klass(latlngs, options);
    this.fireAndForward("editable:created", { layer });
    return layer;
  },
  createPolyline: function(latlngs, options) {
    return this.createLayer(options && options.polylineClass || this.options.polylineClass, latlngs, options);
  },
  createPolygon: function(latlngs, options) {
    return this.createLayer(options && options.polygonClass || this.options.polygonClass, latlngs, options);
  },
  createMarker: function(latlng, options) {
    return this.createLayer(options && options.markerClass || this.options.markerClass, latlng, options);
  },
  createRectangle: function(bounds, options) {
    return this.createLayer(options && options.rectangleClass || this.options.rectangleClass, bounds, options);
  },
  createCircle: function(latlng, options) {
    return this.createLayer(options && options.circleClass || this.options.circleClass, latlng, options);
  }
});
L$2.extend(L$2.Editable, {
  makeCancellable: function(e2) {
    e2.cancel = function() {
      e2._cancelled = true;
    };
  }
});
L$2.Map.mergeOptions({
  editToolsClass: L$2.Editable,
  editable: false,
  editOptions: {}
});
L$2.Map.addInitHook(function() {
  this.whenReady(function() {
    if (this.options.editable) {
      this.editTools = new this.options.editToolsClass(this, this.options.editOptions);
    }
  });
});
L$2.Editable.VertexIcon = L$2.DivIcon.extend({
  options: {
    iconSize: new L$2.Point(28, 28)
  }
});
L$2.Editable.TouchVertexIcon = L$2.Editable.VertexIcon.extend({
  options: {
    iconSize: new L$2.Point(28, 28)
  }
});
L$2.Editable.VertexMarker = L$2.Marker.extend({
  options: {
    draggable: true,
    className: "leaflet-div-icon leaflet-vertex-icon"
  },
  initialize: function(latlng, latlngs, editor, options) {
    this.latlng = latlng;
    this.latlngs = latlngs;
    this.editor = editor;
    L$2.Marker.prototype.initialize.call(this, latlng, options);
    this.options.icon = this.editor.tools.createVertexIcon({
      className: this.options.className
    });
    this.latlng.__vertex = this;
    this.editor.editLayer.addLayer(this);
    this.setZIndexOffset(editor.tools._lastZIndex + 1);
  },
  onAdd: function(map) {
    L$2.Marker.prototype.onAdd.call(this, map);
    this.on("drag", this.onDrag);
    this.on("dragstart", this.onDragStart);
    this.on("dragend", this.onDragEnd);
    this.on("mouseup", this.onMouseup);
    this.on("click", this.onClick);
    this.on("contextmenu", this.onContextMenu);
    this.on("mousedown touchstart", this.onMouseDown);
    this.on("mouseover", this.onMouseOver);
    this.on("mouseout", this.onMouseOut);
    this.addMiddleMarkers();
  },
  onRemove: function(map) {
    if (this.middleMarker)
      this.middleMarker.delete();
    delete this.latlng.__vertex;
    this.off("drag", this.onDrag);
    this.off("dragstart", this.onDragStart);
    this.off("dragend", this.onDragEnd);
    this.off("mouseup", this.onMouseup);
    this.off("click", this.onClick);
    this.off("contextmenu", this.onContextMenu);
    this.off("mousedown touchstart", this.onMouseDown);
    this.off("mouseover", this.onMouseOver);
    this.off("mouseout", this.onMouseOut);
    L$2.Marker.prototype.onRemove.call(this, map);
  },
  onDrag: function(e2) {
    e2.vertex = this;
    this.editor.onVertexMarkerDrag(e2);
    var iconPos = L$2.DomUtil.getPosition(this._icon), latlng = this._map.layerPointToLatLng(iconPos);
    this.latlng.update(latlng);
    this._latlng = this.latlng;
    this.editor.refresh();
    if (this.middleMarker)
      this.middleMarker.updateLatLng();
    var next = this.getNext();
    if (next && next.middleMarker)
      next.middleMarker.updateLatLng();
  },
  onDragStart: function(e2) {
    e2.vertex = this;
    this.editor.onVertexMarkerDragStart(e2);
  },
  onDragEnd: function(e2) {
    e2.vertex = this;
    this.editor.onVertexMarkerDragEnd(e2);
  },
  onClick: function(e2) {
    e2.vertex = this;
    this.editor.onVertexMarkerClick(e2);
  },
  onMouseup: function(e2) {
    L$2.DomEvent.stop(e2);
    e2.vertex = this;
    this.editor.map.fire("mouseup", e2);
  },
  onContextMenu: function(e2) {
    e2.vertex = this;
    this.editor.onVertexMarkerContextMenu(e2);
  },
  onMouseDown: function(e2) {
    e2.vertex = this;
    this.editor.onVertexMarkerMouseDown(e2);
  },
  onMouseOver: function(e2) {
    e2.vertex = this;
    this.editor.onVertexMarkerMouseOver(e2);
  },
  onMouseOut: function(e2) {
    e2.vertex = this;
    this.editor.onVertexMarkerMouseOut(e2);
  },
  delete: function() {
    var next = this.getNext();
    this.latlngs.splice(this.getIndex(), 1);
    this.editor.editLayer.removeLayer(this);
    this.editor.onVertexDeleted({ latlng: this.latlng, vertex: this });
    if (!this.latlngs.length)
      this.editor.deleteShape(this.latlngs);
    if (next)
      next.resetMiddleMarker();
    this.editor.refresh();
  },
  getIndex: function() {
    return this.latlngs.indexOf(this.latlng);
  },
  getLastIndex: function() {
    return this.latlngs.length - 1;
  },
  getPrevious: function() {
    if (this.latlngs.length < 2)
      return;
    var index = this.getIndex(), previousIndex = index - 1;
    if (index === 0 && this.editor.CLOSED)
      previousIndex = this.getLastIndex();
    var previous = this.latlngs[previousIndex];
    if (previous)
      return previous.__vertex;
  },
  getNext: function() {
    if (this.latlngs.length < 2)
      return;
    var index = this.getIndex(), nextIndex = index + 1;
    if (index === this.getLastIndex() && this.editor.CLOSED)
      nextIndex = 0;
    var next = this.latlngs[nextIndex];
    if (next)
      return next.__vertex;
  },
  addMiddleMarker: function(previous) {
    if (!this.editor.hasMiddleMarkers())
      return;
    previous = previous || this.getPrevious();
    if (previous && !this.middleMarker)
      this.middleMarker = this.editor.addMiddleMarker(previous, this, this.latlngs, this.editor);
  },
  addMiddleMarkers: function() {
    if (!this.editor.hasMiddleMarkers())
      return;
    var previous = this.getPrevious();
    if (previous)
      this.addMiddleMarker(previous);
    var next = this.getNext();
    if (next)
      next.resetMiddleMarker();
  },
  resetMiddleMarker: function() {
    if (this.middleMarker)
      this.middleMarker.delete();
    this.addMiddleMarker();
  },
  split: function() {
    if (!this.editor.splitShape)
      return;
    this.editor.splitShape(this.latlngs, this.getIndex());
  },
  continue: function() {
    if (!this.editor.continueBackward)
      return;
    var index = this.getIndex();
    if (index === 0)
      this.editor.continueBackward(this.latlngs);
    else if (index === this.getLastIndex())
      this.editor.continueForward(this.latlngs);
  }
});
L$2.Editable.mergeOptions({
  vertexMarkerClass: L$2.Editable.VertexMarker
});
L$2.Editable.MiddleMarker = L$2.Marker.extend({
  options: {
    opacity: 1,
    className: "leaflet-div-icon leaflet-middle-icon",
    draggable: true
  },
  initialize: function(left, right, latlngs, editor, options) {
    this.left = left;
    this.right = right;
    this.editor = editor;
    this.latlngs = latlngs;
    L$2.Marker.prototype.initialize.call(this, this.computeLatLng(), options);
    this._opacity = this.options.opacity;
    this.options.icon = this.editor.tools.createVertexIcon({
      className: this.options.className,
      html: this.getSideLengthHtml()
    });
    this.editor.editLayer.addLayer(this);
    this.setVisibility();
  },
  setVisibility: function() {
  },
  show: function() {
    this.setOpacity(this._opacity);
  },
  hide: function() {
    this.setOpacity(0);
  },
  updateLatLng: function() {
    this.setLatLng(this.computeLatLng());
    this.setIcon(this.editor.tools.createVertexIcon({
      className: this.options.className,
      html: this.getSideLengthHtml()
    }));
    this.setVisibility();
  },
  getSideLengthHtml: function() {
    const isShowSideLength = !!this.editor.tools.options.isShowSideLength;
    if (!isShowSideLength)
      return "";
    return '<span class="leaflet-middle-icon-length">' + this.editor.map.distance(this.left.latlng, this.right.latlng).toFixed(2) + "m</span>";
  },
  computeLatLng: function() {
    var leftPoint = this.editor.map.latLngToContainerPoint(this.left.latlng), rightPoint = this.editor.map.latLngToContainerPoint(this.right.latlng), y2 = (leftPoint.y + rightPoint.y) / 2, x2 = (leftPoint.x + rightPoint.x) / 2;
    return this.editor.map.containerPointToLatLng([x2, y2]);
  },
  onAdd: function(map) {
    L$2.Marker.prototype.onAdd.call(this, map);
    L$2.DomEvent.on(this._icon, "mousedown touchstart", this.onMouseDown, this);
    map.on("zoomend", this.setVisibility, this);
  },
  onRemove: function(map) {
    delete this.right.middleMarker;
    L$2.DomEvent.off(this._icon, "mousedown touchstart", this.onMouseDown, this);
    map.off("zoomend", this.setVisibility, this);
    L$2.Marker.prototype.onRemove.call(this, map);
  },
  onMouseDown: function(e2) {
    var iconPos = L$2.DomUtil.getPosition(this._icon), latlng = this.editor.map.layerPointToLatLng(iconPos);
    e2 = {
      originalEvent: e2,
      latlng
    };
    if (this.options.opacity === 0)
      return;
    L$2.Editable.makeCancellable(e2);
    this.editor.onMiddleMarkerMouseDown(e2);
    if (e2._cancelled)
      return;
    this.latlngs.splice(this.index(), 0, e2.latlng);
    this.editor.refresh();
    var icon = this._icon;
    var marker = this.editor.addVertexMarker(e2.latlng, this.latlngs);
    this.editor.onNewVertex(marker);
    var parent = marker._icon.parentNode;
    parent.removeChild(marker._icon);
    marker._icon = icon;
    parent.appendChild(marker._icon);
    marker._initIcon();
    marker._initInteraction();
    marker.setOpacity(1);
    L$2.Draggable._dragging = false;
    marker.dragging._draggable._onDown(e2.originalEvent);
    this.delete();
  },
  delete: function() {
    this.editor.editLayer.removeLayer(this);
  },
  index: function() {
    return this.latlngs.indexOf(this.right.latlng);
  }
});
L$2.Editable.mergeOptions({
  middleMarkerClass: L$2.Editable.MiddleMarker
});
L$2.Editable.BaseEditor = L$2.Handler.extend({
  initialize: function(map, feature, options) {
    L$2.setOptions(this, options);
    this.map = map;
    this.feature = feature;
    this.feature.editor = this;
    this.editLayer = new L$2.LayerGroup();
    this.tools = this.options.editTools || map.editTools;
  },
  addHooks: function() {
    if (this.isConnected())
      this.onFeatureAdd();
    else
      this.feature.once("add", this.onFeatureAdd, this);
    this.onEnable();
    this.feature.on(this._getEvents(), this);
  },
  removeHooks: function() {
    this.feature.off(this._getEvents(), this);
    if (this.feature.dragging)
      this.feature.dragging.disable();
    this.editLayer.clearLayers();
    this.tools.editLayer.removeLayer(this.editLayer);
    this.onDisable();
    if (this._drawing)
      this.cancelDrawing();
  },
  drawing: function() {
    return !!this._drawing;
  },
  reset: function() {
  },
  onFeatureAdd: function() {
    this.tools.editLayer.addLayer(this.editLayer);
    if (this.feature.dragging)
      this.feature.dragging.enable();
  },
  hasMiddleMarkers: function() {
    return !this.options.skipMiddleMarkers && !this.tools.options.skipMiddleMarkers;
  },
  fireAndForward: function(type, e2) {
    e2 = e2 || {};
    e2.layer = this.feature;
    this.feature.fire(type, e2);
    this.tools.fireAndForward(type, e2);
  },
  onEnable: function() {
    this.fireAndForward("editable:enable");
  },
  onDisable: function() {
    this.fireAndForward("editable:disable");
  },
  onEditing: function() {
    this.fireAndForward("editable:editing");
  },
  onStartDrawing: function() {
    this.fireAndForward("editable:drawing:start");
  },
  onEndDrawing: function() {
    this.fireAndForward("editable:drawing:end");
  },
  onCancelDrawing: function() {
    this.fireAndForward("editable:drawing:cancel");
  },
  onCommitDrawing: function(e2) {
    this.fireAndForward("editable:drawing:commit", e2);
  },
  onDrawingMouseDown: function(e2) {
    this.fireAndForward("editable:drawing:mousedown", e2);
  },
  onDrawingMouseUp: function(e2) {
    this.fireAndForward("editable:drawing:mouseup", e2);
  },
  startDrawing: function() {
    if (!this._drawing)
      this._drawing = L$2.Editable.FORWARD;
    this.tools.registerForDrawing(this);
    this.onStartDrawing();
  },
  commitDrawing: function(e2) {
    this.onCommitDrawing(e2);
    this.endDrawing();
  },
  cancelDrawing: function() {
    L$2.Draggable._dragging = false;
    this.onCancelDrawing();
    this.endDrawing();
  },
  endDrawing: function() {
    this._drawing = false;
    this.tools.unregisterForDrawing(this);
    this.onEndDrawing();
  },
  onDrawingClick: function(e2) {
    if (!this.drawing())
      return;
    L$2.Editable.makeCancellable(e2);
    this.fireAndForward("editable:drawing:click", e2);
    if (e2._cancelled)
      return;
    if (!this.isConnected())
      this.connect(e2);
    this.processDrawingClick(e2);
  },
  isConnected: function() {
    return this.map.hasLayer(this.feature);
  },
  connect: function() {
    this.tools.connectCreatedToMap(this.feature);
    this.tools.editLayer.addLayer(this.editLayer);
  },
  onMove: function(e2) {
    this.fireAndForward("editable:drawing:move", e2);
  },
  onDrawingMouseMove: function(e2) {
    this.onMove(e2);
  },
  _getEvents: function() {
    return {
      dragstart: this.onDragStart,
      drag: this.onDrag,
      dragend: this.onDragEnd,
      remove: this.disable
    };
  },
  onDragStart: function(e2) {
    this.onEditing();
    this.fireAndForward("editable:dragstart", e2);
  },
  onDrag: function(e2) {
    this.onMove(e2);
    this.fireAndForward("editable:drag", e2);
  },
  onDragEnd: function(e2) {
    this.fireAndForward("editable:dragend", e2);
  }
});
L$2.Editable.MarkerEditor = L$2.Editable.BaseEditor.extend({
  onDrawingMouseMove: function(e2) {
    L$2.Editable.BaseEditor.prototype.onDrawingMouseMove.call(this, e2);
    if (this._drawing)
      this.feature.setLatLng(e2.latlng);
  },
  processDrawingClick: function(e2) {
    this.fireAndForward("editable:drawing:clicked", e2);
    this.commitDrawing(e2);
  },
  connect: function(e2) {
    if (e2)
      this.feature._latlng = e2.latlng;
    L$2.Editable.BaseEditor.prototype.connect.call(this, e2);
  }
});
L$2.Editable.PathEditor = L$2.Editable.BaseEditor.extend({
  CLOSED: false,
  MIN_VERTEX: 2,
  addHooks: function() {
    L$2.Editable.BaseEditor.prototype.addHooks.call(this);
    if (this.feature)
      this.initVertexMarkers();
    return this;
  },
  initVertexMarkers: function(latlngs) {
    if (!this.enabled())
      return;
    latlngs = latlngs || this.getLatLngs();
    if (isFlat(latlngs))
      this.addVertexMarkers(latlngs);
    else
      for (var i2 = 0; i2 < latlngs.length; i2++)
        this.initVertexMarkers(latlngs[i2]);
  },
  getLatLngs: function() {
    return this.feature.getLatLngs();
  },
  reset: function() {
    this.editLayer.clearLayers();
    this.initVertexMarkers();
  },
  addVertexMarker: function(latlng, latlngs) {
    return new this.tools.options.vertexMarkerClass(latlng, latlngs, this);
  },
  onNewVertex: function(vertex) {
    this.fireAndForward("editable:vertex:new", {
      latlng: vertex.latlng,
      vertex
    });
  },
  addVertexMarkers: function(latlngs) {
    for (var i2 = 0; i2 < latlngs.length; i2++) {
      this.addVertexMarker(latlngs[i2], latlngs);
    }
  },
  refreshVertexMarkers: function(latlngs) {
    latlngs = latlngs || this.getDefaultLatLngs();
    for (var i2 = 0; i2 < latlngs.length; i2++) {
      latlngs[i2].__vertex.update();
    }
  },
  addMiddleMarker: function(left, right, latlngs) {
    return new this.tools.options.middleMarkerClass(left, right, latlngs, this);
  },
  onVertexMarkerClick: function(e2) {
    L$2.Editable.makeCancellable(e2);
    this.fireAndForward("editable:vertex:click", e2);
    if (e2._cancelled)
      return;
    if (this.tools.drawing() && this.tools._drawingEditor !== this)
      return;
    var index = e2.vertex.getIndex(), commit;
    if (e2.originalEvent.ctrlKey) {
      this.onVertexMarkerCtrlClick(e2);
    } else if (e2.originalEvent.altKey) {
      this.onVertexMarkerAltClick(e2);
    } else if (e2.originalEvent.shiftKey) {
      this.onVertexMarkerShiftClick(e2);
    } else if (e2.originalEvent.metaKey) {
      this.onVertexMarkerMetaKeyClick(e2);
    } else if (index === e2.vertex.getLastIndex() && this._drawing === L$2.Editable.FORWARD) {
      if (index >= this.MIN_VERTEX - 1)
        commit = true;
    } else if (index === 0 && this._drawing === L$2.Editable.BACKWARD && this._drawnLatLngs.length >= this.MIN_VERTEX) {
      commit = true;
    } else if (index === 0 && this._drawing === L$2.Editable.FORWARD && this._drawnLatLngs.length >= this.MIN_VERTEX && this.CLOSED) {
      commit = true;
    } else {
      this.onVertexRawMarkerClick(e2);
    }
    this.fireAndForward("editable:vertex:clicked", e2);
    if (commit)
      this.commitDrawing(e2);
  },
  onVertexRawMarkerClick: function(e2) {
    this.fireAndForward("editable:vertex:rawclick", e2);
    if (e2._cancelled)
      return;
    if (!this.vertexCanBeDeleted(e2.vertex))
      return;
    e2.vertex.delete();
  },
  vertexCanBeDeleted: function(vertex) {
    return vertex.latlngs.length > this.MIN_VERTEX;
  },
  onVertexDeleted: function(e2) {
    this.fireAndForward("editable:vertex:deleted", e2);
  },
  onVertexMarkerCtrlClick: function(e2) {
    this.fireAndForward("editable:vertex:ctrlclick", e2);
  },
  onVertexMarkerShiftClick: function(e2) {
    this.fireAndForward("editable:vertex:shiftclick", e2);
  },
  onVertexMarkerMetaKeyClick: function(e2) {
    this.fireAndForward("editable:vertex:metakeyclick", e2);
  },
  onVertexMarkerAltClick: function(e2) {
    this.fireAndForward("editable:vertex:altclick", e2);
  },
  onVertexMarkerContextMenu: function(e2) {
    this.fireAndForward("editable:vertex:contextmenu", e2);
  },
  onVertexMarkerMouseDown: function(e2) {
    this.fireAndForward("editable:vertex:mousedown", e2);
  },
  onVertexMarkerMouseOver: function(e2) {
    this.fireAndForward("editable:vertex:mouseover", e2);
  },
  onVertexMarkerMouseOut: function(e2) {
    this.fireAndForward("editable:vertex:mouseout", e2);
  },
  onMiddleMarkerMouseDown: function(e2) {
    this.fireAndForward("editable:middlemarker:mousedown", e2);
  },
  onVertexMarkerDrag: function(e2) {
    this.onMove(e2);
    if (this.feature._bounds)
      this.extendBounds(e2);
    this.fireAndForward("editable:vertex:drag", e2);
  },
  onVertexMarkerDragStart: function(e2) {
    this.fireAndForward("editable:vertex:dragstart", e2);
  },
  onVertexMarkerDragEnd: function(e2) {
    this.fireAndForward("editable:vertex:dragend", e2);
  },
  setDrawnLatLngs: function(latlngs) {
    this._drawnLatLngs = latlngs || this.getDefaultLatLngs();
  },
  startDrawing: function() {
    if (!this._drawnLatLngs)
      this.setDrawnLatLngs();
    L$2.Editable.BaseEditor.prototype.startDrawing.call(this);
  },
  startDrawingForward: function() {
    this.startDrawing();
  },
  endDrawing: function() {
    this.tools.detachForwardLineGuide();
    this.tools.detachBackwardLineGuide();
    if (this._drawnLatLngs && this._drawnLatLngs.length < this.MIN_VERTEX)
      this.deleteShape(this._drawnLatLngs);
    L$2.Editable.BaseEditor.prototype.endDrawing.call(this);
    delete this._drawnLatLngs;
  },
  addLatLng: function(latlng) {
    if (this._drawing === L$2.Editable.FORWARD)
      this._drawnLatLngs.push(latlng);
    else
      this._drawnLatLngs.unshift(latlng);
    this.feature._bounds.extend(latlng);
    var vertex = this.addVertexMarker(latlng, this._drawnLatLngs);
    this.onNewVertex(vertex);
    this.refresh();
  },
  newPointForward: function(latlng) {
    this.addLatLng(latlng);
    this.tools.attachForwardLineGuide();
    this.tools.anchorForwardLineGuide(latlng);
  },
  newPointBackward: function(latlng) {
    this.addLatLng(latlng);
    this.tools.anchorBackwardLineGuide(latlng);
  },
  push: function(latlng) {
    if (!latlng)
      return console.error("L.Editable.PathEditor.push expect a valid latlng as parameter");
    if (this._drawing === L$2.Editable.FORWARD)
      this.newPointForward(latlng);
    else
      this.newPointBackward(latlng);
  },
  removeLatLng: function(latlng) {
    latlng.__vertex.delete();
    this.refresh();
  },
  pop: function() {
    if (this._drawnLatLngs.length <= 1)
      return;
    var latlng;
    if (this._drawing === L$2.Editable.FORWARD)
      latlng = this._drawnLatLngs[this._drawnLatLngs.length - 1];
    else
      latlng = this._drawnLatLngs[0];
    this.removeLatLng(latlng);
    if (this._drawing === L$2.Editable.FORWARD)
      this.tools.anchorForwardLineGuide(this._drawnLatLngs[this._drawnLatLngs.length - 1]);
    else
      this.tools.anchorForwardLineGuide(this._drawnLatLngs[0]);
    return latlng;
  },
  processDrawingClick: function(e2) {
    if (e2.vertex && e2.vertex.editor === this)
      return;
    if (this._drawing === L$2.Editable.FORWARD)
      this.newPointForward(e2.latlng);
    else
      this.newPointBackward(e2.latlng);
    this.fireAndForward("editable:drawing:clicked", e2);
  },
  onDrawingMouseMove: function(e2) {
    L$2.Editable.BaseEditor.prototype.onDrawingMouseMove.call(this, e2);
    if (this._drawing) {
      this.tools.moveForwardLineGuide(e2.latlng);
      this.tools.moveBackwardLineGuide(e2.latlng);
    }
  },
  refresh: function() {
    this.feature.redraw();
    this.onEditing();
  },
  newShape: function(latlng) {
    var shape = this.addNewEmptyShape();
    if (!shape)
      return;
    this.setDrawnLatLngs(shape[0] || shape);
    this.startDrawingForward();
    this.fireAndForward("editable:shape:new", { shape });
    if (latlng)
      this.newPointForward(latlng);
  },
  deleteShape: function(shape, latlngs) {
    var e2 = { shape };
    L$2.Editable.makeCancellable(e2);
    this.fireAndForward("editable:shape:delete", e2);
    if (e2._cancelled)
      return;
    shape = this._deleteShape(shape, latlngs);
    if (this.ensureNotFlat)
      this.ensureNotFlat();
    this.feature.setLatLngs(this.getLatLngs());
    this.refresh();
    this.reset();
    this.fireAndForward("editable:shape:deleted", { shape });
    return shape;
  },
  _deleteShape: function(shape, latlngs) {
    latlngs = latlngs || this.getLatLngs();
    if (!latlngs.length)
      return;
    var self2 = this, inplaceDelete = function(latlngs2, shape2) {
      shape2 = latlngs2.splice(0, Number.MAX_VALUE);
      return shape2;
    }, spliceDelete = function(latlngs2, shape2) {
      latlngs2.splice(latlngs2.indexOf(shape2), 1);
      if (!latlngs2.length)
        self2._deleteShape(latlngs2);
      return shape2;
    };
    if (latlngs === shape)
      return inplaceDelete(latlngs, shape);
    for (var i2 = 0; i2 < latlngs.length; i2++) {
      if (latlngs[i2] === shape)
        return spliceDelete(latlngs, shape);
      else if (latlngs[i2].indexOf(shape) !== -1)
        return spliceDelete(latlngs[i2], shape);
    }
  },
  deleteShapeAt: function(latlng) {
    var shape = this.feature.shapeAt(latlng);
    if (shape)
      return this.deleteShape(shape);
  },
  appendShape: function(shape) {
    this.insertShape(shape);
  },
  prependShape: function(shape) {
    this.insertShape(shape, 0);
  },
  insertShape: function(shape, index) {
    this.ensureMulti();
    shape = this.formatShape(shape);
    if (typeof index === "undefined")
      index = this.feature._latlngs.length;
    this.feature._latlngs.splice(index, 0, shape);
    this.feature.redraw();
    if (this._enabled)
      this.reset();
  },
  extendBounds: function(e2) {
    this.feature._bounds.extend(e2.vertex.latlng);
  },
  onDragStart: function(e2) {
    this.editLayer.clearLayers();
    L$2.Editable.BaseEditor.prototype.onDragStart.call(this, e2);
  },
  onDragEnd: function(e2) {
    this.initVertexMarkers();
    L$2.Editable.BaseEditor.prototype.onDragEnd.call(this, e2);
  }
});
L$2.Editable.PolylineEditor = L$2.Editable.PathEditor.extend({
  startDrawingBackward: function() {
    this._drawing = L$2.Editable.BACKWARD;
    this.startDrawing();
  },
  continueBackward: function(latlngs) {
    if (this.drawing())
      return;
    latlngs = latlngs || this.getDefaultLatLngs();
    this.setDrawnLatLngs(latlngs);
    if (latlngs.length > 0) {
      this.tools.attachBackwardLineGuide();
      this.tools.anchorBackwardLineGuide(latlngs[0]);
    }
    this.startDrawingBackward();
  },
  continueForward: function(latlngs) {
    if (this.drawing())
      return;
    latlngs = latlngs || this.getDefaultLatLngs();
    this.setDrawnLatLngs(latlngs);
    if (latlngs.length > 0) {
      this.tools.attachForwardLineGuide();
      this.tools.anchorForwardLineGuide(latlngs[latlngs.length - 1]);
    }
    this.startDrawingForward();
  },
  getDefaultLatLngs: function(latlngs) {
    latlngs = latlngs || this.feature._latlngs;
    if (!latlngs.length || latlngs[0] instanceof L$2.LatLng)
      return latlngs;
    else
      return this.getDefaultLatLngs(latlngs[0]);
  },
  ensureMulti: function() {
    if (this.feature._latlngs.length && isFlat(this.feature._latlngs)) {
      this.feature._latlngs = [this.feature._latlngs];
    }
  },
  addNewEmptyShape: function() {
    if (this.feature._latlngs.length) {
      var shape = [];
      this.appendShape(shape);
      return shape;
    } else {
      return this.feature._latlngs;
    }
  },
  formatShape: function(shape) {
    if (isFlat(shape))
      return shape;
    else if (shape[0])
      return this.formatShape(shape[0]);
  },
  splitShape: function(shape, index) {
    if (!index || index >= shape.length - 1)
      return;
    this.ensureMulti();
    var shapeIndex = this.feature._latlngs.indexOf(shape);
    if (shapeIndex === -1)
      return;
    var first = shape.slice(0, index + 1), second = shape.slice(index);
    second[0] = L$2.latLng(second[0].lat, second[0].lng, second[0].alt);
    this.feature._latlngs.splice(shapeIndex, 1, first, second);
    this.refresh();
    this.reset();
  }
});
L$2.Editable.PolygonEditor = L$2.Editable.PathEditor.extend({
  CLOSED: true,
  MIN_VERTEX: 3,
  newPointForward: function(latlng) {
    L$2.Editable.PathEditor.prototype.newPointForward.call(this, latlng);
    if (!this.tools.backwardLineGuide._latlngs.length)
      this.tools.anchorBackwardLineGuide(latlng);
    if (this._drawnLatLngs.length === 2)
      this.tools.attachBackwardLineGuide();
  },
  addNewEmptyHole: function(latlng) {
    this.ensureNotFlat();
    var latlngs = this.feature.shapeAt(latlng);
    if (!latlngs)
      return;
    var holes = [];
    latlngs.push(holes);
    return holes;
  },
  newHole: function(latlng) {
    var holes = this.addNewEmptyHole(latlng);
    if (!holes)
      return;
    this.setDrawnLatLngs(holes);
    this.startDrawingForward();
    if (latlng)
      this.newPointForward(latlng);
  },
  addNewEmptyShape: function() {
    if (this.feature._latlngs.length && this.feature._latlngs[0].length) {
      var shape = [];
      this.appendShape(shape);
      return shape;
    } else {
      return this.feature._latlngs;
    }
  },
  ensureMulti: function() {
    if (this.feature._latlngs.length && isFlat(this.feature._latlngs[0])) {
      this.feature._latlngs = [this.feature._latlngs];
    }
  },
  ensureNotFlat: function() {
    if (!this.feature._latlngs.length || isFlat(this.feature._latlngs))
      this.feature._latlngs = [this.feature._latlngs];
  },
  vertexCanBeDeleted: function(vertex) {
    var parent = this.feature.parentShape(vertex.latlngs), idx = L$2.Util.indexOf(parent, vertex.latlngs);
    if (idx > 0)
      return true;
    return L$2.Editable.PathEditor.prototype.vertexCanBeDeleted.call(this, vertex);
  },
  getDefaultLatLngs: function() {
    if (!this.feature._latlngs.length)
      this.feature._latlngs.push([]);
    return this.feature._latlngs[0];
  },
  formatShape: function(shape) {
    if (isFlat(shape) && (!shape[0] || shape[0].length !== 0))
      return [shape];
    else
      return shape;
  }
});
L$2.Editable.RectangleEditor = L$2.Editable.PathEditor.extend({
  CLOSED: true,
  MIN_VERTEX: 4,
  options: {
    skipMiddleMarkers: true
  },
  extendBounds: function(e2) {
    var index = e2.vertex.getIndex(), next = e2.vertex.getNext(), previous = e2.vertex.getPrevious(), oppositeIndex = (index + 2) % 4, opposite = e2.vertex.latlngs[oppositeIndex], bounds = new L$2.LatLngBounds(e2.latlng, opposite);
    previous.latlng.update([e2.latlng.lat, opposite.lng]);
    next.latlng.update([opposite.lat, e2.latlng.lng]);
    this.updateBounds(bounds);
    this.refreshVertexMarkers();
  },
  onDrawingMouseDown: function(e2) {
    L$2.Editable.PathEditor.prototype.onDrawingMouseDown.call(this, e2);
    this.connect();
    var latlngs = this.getDefaultLatLngs();
    if (latlngs.length === 3)
      latlngs.push(e2.latlng);
    var bounds = new L$2.LatLngBounds(e2.latlng, e2.latlng);
    this.updateBounds(bounds);
    this.updateLatLngs(bounds);
    this.refresh();
    this.reset();
    e2.originalEvent._simulated = false;
    this.map.dragging._draggable._onUp(e2.originalEvent);
    latlngs[3].__vertex.dragging._draggable._onDown(e2.originalEvent);
  },
  onDrawingMouseUp: function(e2) {
    this.commitDrawing(e2);
    e2.originalEvent._simulated = false;
    L$2.Editable.PathEditor.prototype.onDrawingMouseUp.call(this, e2);
  },
  onDrawingMouseMove: function(e2) {
    e2.originalEvent._simulated = false;
    L$2.Editable.PathEditor.prototype.onDrawingMouseMove.call(this, e2);
  },
  getDefaultLatLngs: function(latlngs) {
    return latlngs || this.feature._latlngs[0];
  },
  updateBounds: function(bounds) {
    this.feature._bounds = bounds;
  },
  updateLatLngs: function(bounds) {
    var latlngs = this.getDefaultLatLngs(), newLatlngs = this.feature._boundsToLatLngs(bounds);
    for (var i2 = 0; i2 < latlngs.length; i2++) {
      latlngs[i2].update(newLatlngs[i2]);
    }
  }
});
L$2.Editable.CircleEditor = L$2.Editable.PathEditor.extend({
  MIN_VERTEX: 2,
  options: {
    skipMiddleMarkers: true
  },
  initialize: function(map, feature, options) {
    L$2.Editable.PathEditor.prototype.initialize.call(this, map, feature, options);
    this._resizeLatLng = this.computeResizeLatLng();
  },
  computeResizeLatLng: function() {
    var delta = (this.feature._radius || this.feature._mRadius) * Math.cos(Math.PI / 4), point = this.map.project(this.feature._latlng);
    return this.map.unproject([point.x + delta, point.y - delta]);
  },
  updateResizeLatLng: function() {
    this._resizeLatLng.update(this.computeResizeLatLng());
    this._resizeLatLng.__vertex.update();
  },
  getLatLngs: function() {
    return [this.feature._latlng, this._resizeLatLng];
  },
  getDefaultLatLngs: function() {
    return this.getLatLngs();
  },
  onVertexMarkerDrag: function(e2) {
    if (e2.vertex.getIndex() === 1)
      this.resize(e2);
    else
      this.updateResizeLatLng(e2);
    L$2.Editable.PathEditor.prototype.onVertexMarkerDrag.call(this, e2);
  },
  resize: function(e2) {
    var radius = this.feature._latlng.distanceTo(e2.latlng);
    this.feature.setRadius(radius);
  },
  onDrawingMouseDown: function(e2) {
    L$2.Editable.PathEditor.prototype.onDrawingMouseDown.call(this, e2);
    this._resizeLatLng.update(e2.latlng);
    this.feature._latlng.update(e2.latlng);
    this.connect();
    e2.originalEvent._simulated = false;
    this.map.dragging._draggable._onUp(e2.originalEvent);
    this._resizeLatLng.__vertex.dragging._draggable._onDown(e2.originalEvent);
  },
  onDrawingMouseUp: function(e2) {
    this.commitDrawing(e2);
    e2.originalEvent._simulated = false;
    L$2.Editable.PathEditor.prototype.onDrawingMouseUp.call(this, e2);
  },
  onDrawingMouseMove: function(e2) {
    e2.originalEvent._simulated = false;
    L$2.Editable.PathEditor.prototype.onDrawingMouseMove.call(this, e2);
  },
  onDrag: function(e2) {
    L$2.Editable.PathEditor.prototype.onDrag.call(this, e2);
    this.feature.dragging.updateLatLng(this._resizeLatLng);
  }
});
var EditableMixin = {
  createEditor: function(map) {
    map = map || this._map;
    var tools = (this.options.editOptions || {}).editTools || map.editTools;
    if (!tools)
      throw Error("Unable to detect Editable instance.");
    var Klass = this.options.editorClass || this.getEditorClass(tools);
    return new Klass(map, this, this.options.editOptions);
  },
  enableEdit: function(map) {
    if (!this.editor)
      this.createEditor(map);
    this.editor.enable();
    return this.editor;
  },
  editEnabled: function() {
    return this.editor && this.editor.enabled();
  },
  disableEdit: function() {
    if (this.editor) {
      this.editor.disable();
      delete this.editor;
    }
  },
  toggleEdit: function() {
    if (this.editEnabled())
      this.disableEdit();
    else
      this.enableEdit();
  },
  _onEditableAdd: function() {
    if (this.editor)
      this.enableEdit();
  }
};
var PolylineMixin = {
  getEditorClass: function(tools) {
    return tools && tools.options.polylineEditorClass ? tools.options.polylineEditorClass : L$2.Editable.PolylineEditor;
  },
  shapeAt: function(latlng, latlngs) {
    var shape = null;
    latlngs = latlngs || this._latlngs;
    if (!latlngs.length)
      return shape;
    else if (isFlat(latlngs) && this.isInLatLngs(latlng, latlngs))
      shape = latlngs;
    else
      for (var i2 = 0; i2 < latlngs.length; i2++)
        if (this.isInLatLngs(latlng, latlngs[i2]))
          return latlngs[i2];
    return shape;
  },
  isInLatLngs: function(l2, latlngs) {
    if (!latlngs)
      return false;
    var i2, k2, len, part = [], p2, w2 = this._clickTolerance();
    this._projectLatlngs(latlngs, part, this._pxBounds);
    part = part[0];
    p2 = this._map.latLngToLayerPoint(l2);
    if (!this._pxBounds.contains(p2)) {
      return false;
    }
    for (i2 = 1, len = part.length, k2 = 0; i2 < len; k2 = i2++) {
      if (L$2.LineUtil.pointToSegmentDistance(p2, part[k2], part[i2]) <= w2) {
        return true;
      }
    }
    return false;
  }
};
var PolygonMixin = {
  getEditorClass: function(tools) {
    return tools && tools.options.polygonEditorClass ? tools.options.polygonEditorClass : L$2.Editable.PolygonEditor;
  },
  shapeAt: function(latlng, latlngs) {
    var shape = null;
    latlngs = latlngs || this._latlngs;
    if (!latlngs.length)
      return shape;
    else if (isFlat(latlngs) && this.isInLatLngs(latlng, latlngs))
      shape = latlngs;
    else if (isFlat(latlngs[0]) && this.isInLatLngs(latlng, latlngs[0]))
      shape = latlngs;
    else
      for (var i2 = 0; i2 < latlngs.length; i2++)
        if (this.isInLatLngs(latlng, latlngs[i2][0]))
          return latlngs[i2];
    return shape;
  },
  isInLatLngs: function(l2, latlngs) {
    var inside = false, l1, l22, j2, k2, len2;
    for (j2 = 0, len2 = latlngs.length, k2 = len2 - 1; j2 < len2; k2 = j2++) {
      l1 = latlngs[j2];
      l22 = latlngs[k2];
      if (l1.lat > l2.lat !== l22.lat > l2.lat && l2.lng < (l22.lng - l1.lng) * (l2.lat - l1.lat) / (l22.lat - l1.lat) + l1.lng) {
        inside = !inside;
      }
    }
    return inside;
  },
  parentShape: function(shape, latlngs) {
    latlngs = latlngs || this._latlngs;
    if (!latlngs)
      return;
    var idx = L$2.Util.indexOf(latlngs, shape);
    if (idx !== -1)
      return latlngs;
    for (var i2 = 0; i2 < latlngs.length; i2++) {
      idx = L$2.Util.indexOf(latlngs[i2], shape);
      if (idx !== -1)
        return latlngs[i2];
    }
  }
};
var MarkerMixin = {
  getEditorClass: function(tools) {
    return tools && tools.options.markerEditorClass ? tools.options.markerEditorClass : L$2.Editable.MarkerEditor;
  }
};
var RectangleMixin = {
  getEditorClass: function(tools) {
    return tools && tools.options.rectangleEditorClass ? tools.options.rectangleEditorClass : L$2.Editable.RectangleEditor;
  }
};
var CircleMixin = {
  getEditorClass: function(tools) {
    return tools && tools.options.circleEditorClass ? tools.options.circleEditorClass : L$2.Editable.CircleEditor;
  }
};
var keepEditable = function() {
  this.on("add", this._onEditableAdd);
};
var isFlat = L$2.LineUtil.isFlat || L$2.LineUtil._flat || L$2.Polyline._flat;
if (L$2.Polyline) {
  L$2.Polyline.include(EditableMixin);
  L$2.Polyline.include(PolylineMixin);
  L$2.Polyline.addInitHook(keepEditable);
}
if (L$2.Polygon) {
  L$2.Polygon.include(EditableMixin);
  L$2.Polygon.include(PolygonMixin);
}
if (L$2.Marker) {
  L$2.Marker.include(EditableMixin);
  L$2.Marker.include(MarkerMixin);
  L$2.Marker.addInitHook(keepEditable);
}
if (L$2.Rectangle) {
  L$2.Rectangle.include(EditableMixin);
  L$2.Rectangle.include(RectangleMixin);
}
if (L$2.Circle) {
  L$2.Circle.include(EditableMixin);
  L$2.Circle.include(CircleMixin);
}
L$2.LatLng.prototype.update = function(latlng) {
  latlng = L$2.latLng(latlng);
  this.lat = latlng.lat;
  this.lng = latlng.lng;
};
class Layers {
  constructor(options) {
    this.layerMap = new Map();
    this.options = options;
    this.init();
  }
  init() {
    const subdomains = ["t0", "t1", "t2", "t3", "t4", "t5", "t6", "t7"];
    const defaultSatellite = [
      new TileLayer(`https://{s}.tianditu.gov.cn/img_w/wmts?SERVICE=WMTS&REQUEST=GetTile&VERSION=1.0.0&LAYER=img&STYLE=default&TILEMATRIXSET=w&FORMAT=tiles&TILEMATRIX={z}&TILEROW={y}&TILECOL={x}&tk=${this.options.TianDiTuKey}`, {
        subdomains
      }),
      new TileLayer(`https://{s}.tianditu.gov.cn/cia_w/wmts?SERVICE=WMTS&REQUEST=GetTile&VERSION=1.0.0&LAYER=cia&STYLE=default&TILEMATRIXSET=w&FORMAT=tiles&TILEMATRIX={z}&TILEROW={y}&TILECOL={x}&tk=${this.options.TianDiTuKey}`, {
        subdomains
      })
    ];
    const defaultVector = [
      new TileLayer(`https://{s}.tianditu.gov.cn/vec_w/wmts?SERVICE=WMTS&REQUEST=GetTile&VERSION=1.0.0&LAYER=vec&STYLE=default&TILEMATRIXSET=w&FORMAT=tiles&TILEMATRIX={z}&TILEROW={y}&TILECOL={x}&tk=${this.options.TianDiTuKey}`, {
        subdomains
      }),
      new TileLayer(`https://{s}.tianditu.gov.cn/cva_w/wmts?SERVICE=WMTS&REQUEST=GetTile&VERSION=1.0.0&LAYER=cva&STYLE=default&TILEMATRIXSET=w&FORMAT=tiles&TILEMATRIX={z}&TILEROW={y}&TILECOL={x}&tk=${this.options.TianDiTuKey}`, {
        subdomains
      })
    ];
    this.layerMap.set(LayerType.defaultSatellite, defaultSatellite);
    this.layerMap.set(LayerType.defaultVector, defaultVector);
    if (this.options.onLoad) {
      const onLoad = this.options.onLoad;
      Array.from([
        ...this.layerMap.get(LayerType.defaultSatellite).values(),
        ...this.layerMap.get(LayerType.defaultVector).values()
      ]).forEach((layer) => {
        layer.on("load", onLoad);
      });
    }
  }
  getLayerByType(layerType) {
    return this.layerMap.get(layerType);
  }
  changeLayerByType(map, layerType) {
    this.layerMap.forEach((v2, t2) => {
      if (layerType !== t2) {
        v2.forEach((l2) => {
          if (map.hasLayer(l2)) {
            map.removeLayer(l2);
          }
        });
      } else {
        v2.forEach((l2) => {
          if (!map.hasLayer(l2)) {
            map.addLayer(l2);
          }
        });
      }
    });
  }
}
const earthRadius = 63710088e-1;
function area(coords) {
  let p1;
  let p2;
  let p3;
  let lowerIndex;
  let middleIndex;
  let upperIndex;
  let i2;
  let total = 0;
  const coordsLength = coords.length;
  if (coordsLength > 2) {
    for (i2 = 0; i2 < coordsLength; i2++) {
      if (i2 === coordsLength - 2) {
        lowerIndex = coordsLength - 2;
        middleIndex = coordsLength - 1;
        upperIndex = 0;
      } else if (i2 === coordsLength - 1) {
        lowerIndex = coordsLength - 1;
        middleIndex = 0;
        upperIndex = 1;
      } else {
        lowerIndex = i2;
        middleIndex = i2 + 1;
        upperIndex = i2 + 2;
      }
      p1 = coords[lowerIndex];
      p2 = coords[middleIndex];
      p3 = coords[upperIndex];
      total += (rad(p3[1]) - rad(p1[1])) * Math.sin(rad(p2[0]));
    }
    total = total * earthRadius * earthRadius / 2;
  }
  return Math.abs(total);
}
function rad(num) {
  return num * Math.PI / 180;
}
function degreesToRadians(degrees) {
  const radians = degrees % 360;
  return radians * Math.PI / 180;
}
function distance(coordinates1, coordinates2) {
  const dLat = degreesToRadians(coordinates2[0] - coordinates1[0]);
  const dLon = degreesToRadians(coordinates2[1] - coordinates1[1]);
  const lat1 = degreesToRadians(coordinates1[0]);
  const lat2 = degreesToRadians(coordinates2[0]);
  const a2 = Math.pow(Math.sin(dLat / 2), 2) + Math.pow(Math.sin(dLon / 2), 2) * Math.cos(lat1) * Math.cos(lat2);
  return 2 * Math.atan2(Math.sqrt(a2), Math.sqrt(1 - a2)) * earthRadius;
}
function length(coordinates, isClosed) {
  let total = 0;
  const lastIndex = coordinates.length - 1;
  for (let i2 = 0; i2 <= coordinates.length - 1; i2++) {
    if (i2 === lastIndex) {
      if (isClosed) {
        total += distance(coordinates[i2], coordinates[0]);
      }
    } else {
      total += distance(coordinates[i2], coordinates[i2 + 1]);
    }
  }
  return total;
}
function intersects(line1, line2) {
  const x1 = line1[0][1];
  const y1 = line1[0][0];
  const x2 = line1[1][1];
  const y2 = line1[1][0];
  const x3 = line2[0][1];
  const y3 = line2[0][0];
  const x4 = line2[1][1];
  const y4 = line2[1][0];
  const denom = (y4 - y3) * (x2 - x1) - (x4 - x3) * (y2 - y1);
  const numeA = (x4 - x3) * (y1 - y3) - (y4 - y3) * (x1 - x3);
  const numeB = (x2 - x1) * (y1 - y3) - (y2 - y1) * (x1 - x3);
  if (denom === 0) {
    if (numeA === 0 && numeB === 0) {
      return null;
    }
    return null;
  }
  const uA = numeA / denom;
  const uB = numeB / denom;
  if (uA >= 0 && uA <= 1 && uB >= 0 && uB <= 1) {
    const x5 = x1 + uA * (x2 - x1);
    const y5 = y1 + uA * (y2 - y1);
    return [y5, x5];
  }
  return null;
}
function detectLineIntersect(path, isClosed) {
  const pathToSegmentList = (path2) => path2.reduce((acc, cur, index, list) => {
    const start = cur;
    const end = list[index + 1];
    if (end) {
      acc.push([start, end]);
    } else {
      if (isClosed) {
        acc.push([start, list[0]]);
      }
    }
    return acc;
  }, []);
  const segmentList = pathToSegmentList(path);
  const compareMap = {};
  const alreadyCompare = (i2, j2) => {
    if (i2 === j2) {
      return true;
    }
    const key = `${i2}-${j2}`;
    const reverseKey = `${j2}-${i2}`;
    if (compareMap[key] || compareMap[reverseKey]) {
      return true;
    }
    compareMap[key] = compareMap[reverseKey] = true;
    return false;
  };
  const len = segmentList.length;
  for (let i2 = 0; i2 < len; i2++) {
    for (let j2 = 0; j2 < len; j2++) {
      if (!alreadyCompare(i2, j2)) {
        const p1 = segmentList[i2];
        const p2 = segmentList[j2];
        console.log("i, j", i2, j2);
        const sameEndpoint = Math.abs(i2 - j2) === 1 || p1[0][0] === p2[0][0] && p1[0][1] === p2[0][1] || p1[0][0] === p2[1][0] && p1[0][1] === p2[1][1] || p1[1][0] === p2[0][0] && p1[1][1] === p2[0][1] || p1[1][0] === p2[1][0] && p1[1][1] === p2[1][1];
        if (!sameEndpoint) {
          const intersect = intersects(segmentList[i2], segmentList[j2]);
          if (intersect) {
            return true;
          }
        }
      }
    }
  }
  return false;
}
const clonePath = (pointList) => {
  return pointList.map((path) => [...path]);
};
const toClosedPath = (pointList) => {
  return [...pointList, pointList[0]];
};
const toNotClosedPath = (pointList) => {
  const path = clonePath(pointList);
  path.splice(path.length - 1, 1);
  return path;
};
const lngLatToLatLng = (lngLat) => [
  lngLat[1],
  lngLat[0]
];
const lngLatListToLatLngList = (lngLatList) => lngLatList.map((i2) => lngLatToLatLng(i2));
const latLngToLngLat = (latLng) => [
  latLng[1],
  latLng[0]
];
const latLngListToLngLatList = (latLngList) => latLngList.map((i2) => latLngToLngLat(i2));
const calculateCenter = (latLngList) => {
  const len = latLngList.length;
  if (len === 0) {
    return null;
  } else {
    const llb = new LatLngBounds(latLngList);
    const center = llb.getCenter();
    return [center.lat, center.lng];
  }
};
const squareMeterToMu = (num) => {
  return parseFloat((num / 666.6).toFixed(2));
};
const toTwoDecimalPlacesNumber = (n2) => {
  if (n2 === 0) {
    return 0;
  } else {
    return parseFloat(n2.toFixed(2));
  }
};
function getAreaByCoords(coords) {
  return toTwoDecimalPlacesNumber(area(coords));
}
function getLengthByCoords(coords, isClosed) {
  return toTwoDecimalPlacesNumber(length(coords, isClosed));
}
const DEFAULT_COLOR = "#0097FF";
const DEFAULT_INTERSECT_COLOR = "red";
const DEFAULT_WEiGHT = 2;
class Draw {
  constructor(options) {
    this.path = [];
    this.markerList = [];
    this.polygonIsEditing = false;
    this.isClosed = false;
    this.editorEnable = false;
    this.isIntersect = false;
    this.intersectStyle = {
      color: DEFAULT_INTERSECT_COLOR,
      dashArray: [5, 5],
      weight: DEFAULT_WEiGHT
    };
    this.style = {
      dashArray: "",
      color: DEFAULT_COLOR,
      weight: DEFAULT_WEiGHT
    };
    this.handleChangePolygon = (e2) => {
      var _a;
      if (!((_a = e2.layer.options.className) == null ? void 0 : _a.includes(this.polygonIDClassFlag))) {
        return;
      }
      const polygonPath = e2.layer.getLatLngs();
      if (polygonPath && polygonPath.length && polygonPath[0] && polygonPath[0].length) {
        const formatPath = polygonPath[0].map((p2) => [
          p2.lat,
          p2.lng
        ]);
        this.setPath(formatPath);
        this.options.onPolygonPathChange();
      }
    };
    this.options = options;
    this.map = this.options.map;
    this.polygonIDClassFlag = `polygon_id_${this.options.id}`;
  }
  _setStyle(style) {
    if (this.polygon) {
      this.polygon.setStyle(style);
    }
    if (this.polyline) {
      this.polyline.setStyle(style);
    }
  }
  setStyle(style) {
    this.style = __spreadValues(__spreadValues({}, this.style), style);
    this._setStyle(style);
  }
  setFillColor(fillColor) {
    this.setStyle({ fillColor });
  }
  getFillColor() {
    return this.style.fillColor;
  }
  getIsIntersect() {
    return this.isIntersect;
  }
  setIsIntersect(isIntersect) {
    this.isIntersect = isIntersect;
    this.setStyleByIntersectStatus();
  }
  setStyleByIntersectStatus() {
    if (this.isIntersect) {
      this._setStyle(this.intersectStyle);
    } else {
      this._setStyle(this.style);
    }
  }
  detectionIntersect() {
    if (this.options.enableIntersectDetection) {
      const isIntersect = detectLineIntersect(this.path, this.getIsClosed());
      if (this.isIntersect !== isIntersect) {
        this.setIsIntersect(isIntersect);
        this.options.onIntersectStatusChange();
      }
    }
  }
  setPath(path) {
    this.path = clonePath(path);
    this.updateTitlePosition();
    this.detectionIntersect();
  }
  getPath() {
    return clonePath(this.path);
  }
  setTitle(title) {
    this.title = title;
    if (title && title.length > 0) {
      const icon = new DivIcon({
        className: this.options.titleClassName ? this.options.titleClassName : "leaflet-title-icon",
        html: title
      });
      if (!this.titleMarker) {
        this.titleMarker = new Marker(calculateCenter(this.path), {
          icon
        });
        this.map.addLayer(this.titleMarker);
      } else {
        this.titleMarker.setIcon(icon);
      }
    } else {
      this.removeTitleMarker();
    }
  }
  getTitle() {
    return this.title;
  }
  setColor(color) {
    this.setStyle({ color });
  }
  getColor() {
    return this.style.color;
  }
  setWeight(weight) {
    this.setStyle({ weight });
  }
  getWeight() {
    return this.style.weight;
  }
  setIsClosed(isClosed) {
    this.isClosed = isClosed;
  }
  getIsClosed() {
    return this.isClosed;
  }
  setEditorEnable(editorEnable) {
    this.editorEnable = editorEnable;
    if (editorEnable) {
      this.polygonEnableEditor();
    } else {
      this.polygonDisableEditor();
    }
  }
  getEditorEnable() {
    return this.editorEnable;
  }
  getArea() {
    if (this.isClosed) {
      return toTwoDecimalPlacesNumber(area(this.path));
    } else {
      return 0;
    }
  }
  getLength() {
    if (this.path.length && this.path.length > 1) {
      return toTwoDecimalPlacesNumber(length(this.path, this.isClosed));
    } else {
      return 0;
    }
  }
  drawing() {
    var _a, _b, _c;
    if (this.options.onlyShowTitle)
      return;
    if (this.isClosed) {
      if (!this.polygon) {
        this.removeMakerList();
        this.removePolyline();
        this.polygon = this.getPolygon([]);
        this.setStyleByIntersectStatus();
        this.map.addLayer(this.polygon);
        if (this.editorEnable) {
          this.polygonEnableEditor();
        }
      }
      if (this.polygonIsEditing) {
        this.polygon.disableEdit();
      }
      this.polygon.setLatLngs(clonePath(this.path));
      if (this.polygonIsEditing) {
        setTimeout(() => {
          var _a2;
          (_a2 = this.polygon) == null ? void 0 : _a2.enableEdit();
        }, 45);
      }
      (_a = this.titleMarker) == null ? void 0 : _a.setLatLng(calculateCenter(this.path));
    } else {
      this.removePolygon();
      const path = clonePath(this.path);
      const markerList = this.markerList;
      const count = Math.max(path.length, markerList.length);
      for (let i2 = 0; i2 < count; i2++) {
        if (path[i2] && !markerList[i2]) {
          const marker = this.getMarkerInstance(path[i2]);
          this.markerList.push(marker);
          this.map.addLayer(marker);
        } else if (!path[i2] && markerList[i2]) {
          const marker = markerList[i2];
          this.map.removeLayer(marker);
          markerList.splice(i2, 1);
        }
      }
      if (path.length < 2) {
        (_b = this.polyline) == null ? void 0 : _b.remove();
        this.polyline = void 0;
      } else {
        if (!this.polyline) {
          this.polyline = this.getPolylineInstance();
          this.setStyleByIntersectStatus();
          this.map.addLayer(this.polyline);
        }
        (_c = this.polyline) == null ? void 0 : _c.setLatLngs(clonePath(path));
      }
    }
  }
  drawingThumbIcon(showThumbnail) {
    if (this.options.onlyShowTitle)
      return;
    if (showThumbnail) {
      if (!this.thumbnailIcon) {
        this.removeAllDrawing();
        this.thumbnailIcon = new Marker(calculateCenter(this.path), {
          interactive: false,
          icon: new DivIcon({
            iconSize: ICON_SIZE,
            className: "leaflet-thumb-icon"
          })
        });
        this.map.addLayer(this.thumbnailIcon);
      } else {
        this.thumbnailIcon.setLatLng(calculateCenter(this.path));
      }
    } else {
      if (this.thumbnailIcon) {
        this.removeThumbnailIcon();
        this.drawing();
      }
    }
  }
  destroy() {
    this.removeTitleMarker();
    this.removeAllDrawing();
  }
  updateTitlePosition() {
    var _a;
    if (this.path && this.path.length) {
      (_a = this.titleMarker) == null ? void 0 : _a.setLatLng(calculateCenter(this.path));
    }
  }
  removeMakerList() {
    this.markerList.forEach((marker) => {
      this.map.removeLayer(marker);
    });
    this.markerList = [];
  }
  removePolyline() {
    if (this.polyline) {
      this.map.removeLayer(this.polyline);
      this.polyline = void 0;
    }
  }
  removePolygon() {
    if (this.polygon) {
      this.polygonDisableEditor();
      this.map.removeLayer(this.polygon);
      this.polygon = void 0;
    }
  }
  removeThumbnailIcon() {
    if (this.thumbnailIcon) {
      this.map.removeLayer(this.thumbnailIcon);
      this.thumbnailIcon = void 0;
    }
  }
  removeTitleMarker() {
    if (this.titleMarker) {
      this.map.removeLayer(this.titleMarker);
      this.titleMarker = void 0;
    }
  }
  removeAllDrawing() {
    this.removeMakerList();
    this.removePolyline();
    this.removePolygon();
    this.removeThumbnailIcon();
  }
  polygonEnableEditor() {
    var _a;
    if (!this.editorEnable || this.polygonIsEditing)
      return;
    this.polygonIsEditing = true;
    this.options.map.on("editable:vertex:dragend", this.handleChangePolygon);
    this.options.map.on("editable:vertex:deleted", (e2) => {
      this.handleChangePolygon(e2);
    });
    (_a = this.polygon) == null ? void 0 : _a.enableEdit();
  }
  polygonDisableEditor() {
    var _a;
    if (!this.polygonIsEditing)
      return;
    this.polygonIsEditing = false;
    (_a = this.polygon) == null ? void 0 : _a.disableEdit();
    this.options.map.off("editable:vertex:dragend", this.handleChangePolygon);
    this.options.map.off("editable:vertex:deleted", this.handleChangePolygon);
  }
  getMarkerInstance(point) {
    const marker = new Marker(point, __spreadValues({
      interactive: false,
      icon: new DivIcon({
        iconSize: ICON_SIZE,
        className: `leaflet-vertex-icon leaflet-vertex-icon-${this.options.id}`
      })
    }, this.options.markerOptions));
    return marker;
  }
  getPolylineInstance() {
    const polyline = new Polyline([], __spreadValues(__spreadValues({}, this.style), this.options.polylineOptions));
    return polyline;
  }
  getPolygon(latlngs) {
    const polygon = new Polygon(latlngs, __spreadValues(__spreadValues({
      className: this.polygonIDClassFlag
    }, this.style), this.options.polygonOptions));
    return polygon;
  }
}
var n, l$1, u$1, t$1, r$1, o$1, e$1 = {}, c$1 = [], s$1 = /acit|ex(?:s|g|n|p|$)|rph|grid|ows|mnc|ntw|ine[ch]|zoo|^ord|itera/i;
function a$1(n2, l2) {
  for (var u2 in l2)
    n2[u2] = l2[u2];
  return n2;
}
function h$1(n2) {
  var l2 = n2.parentNode;
  l2 && l2.removeChild(n2);
}
function v$1(l2, u2, i2) {
  var t2, r2, o2, f2 = {};
  for (o2 in u2)
    o2 == "key" ? t2 = u2[o2] : o2 == "ref" ? r2 = u2[o2] : f2[o2] = u2[o2];
  if (arguments.length > 2 && (f2.children = arguments.length > 3 ? n.call(arguments, 2) : i2), typeof l2 == "function" && l2.defaultProps != null)
    for (o2 in l2.defaultProps)
      f2[o2] === void 0 && (f2[o2] = l2.defaultProps[o2]);
  return y$1(l2, f2, t2, r2, null);
}
function y$1(n2, i2, t2, r2, o2) {
  var f2 = { type: n2, props: i2, key: t2, ref: r2, __k: null, __: null, __b: 0, __e: null, __d: void 0, __c: null, __h: null, constructor: void 0, __v: o2 == null ? ++u$1 : o2 };
  return o2 == null && l$1.vnode != null && l$1.vnode(f2), f2;
}
function p$1() {
  return { current: null };
}
function d(n2) {
  return n2.children;
}
function _$1(n2, l2) {
  this.props = n2, this.context = l2;
}
function k$1(n2, l2) {
  if (l2 == null)
    return n2.__ ? k$1(n2.__, n2.__.__k.indexOf(n2) + 1) : null;
  for (var u2; l2 < n2.__k.length; l2++)
    if ((u2 = n2.__k[l2]) != null && u2.__e != null)
      return u2.__e;
  return typeof n2.type == "function" ? k$1(n2) : null;
}
function b$1(n2) {
  var l2, u2;
  if ((n2 = n2.__) != null && n2.__c != null) {
    for (n2.__e = n2.__c.base = null, l2 = 0; l2 < n2.__k.length; l2++)
      if ((u2 = n2.__k[l2]) != null && u2.__e != null) {
        n2.__e = n2.__c.base = u2.__e;
        break;
      }
    return b$1(n2);
  }
}
function m$1(n2) {
  (!n2.__d && (n2.__d = true) && t$1.push(n2) && !g$1.__r++ || o$1 !== l$1.debounceRendering) && ((o$1 = l$1.debounceRendering) || r$1)(g$1);
}
function g$1() {
  for (var n2; g$1.__r = t$1.length; )
    n2 = t$1.sort(function(n3, l2) {
      return n3.__v.__b - l2.__v.__b;
    }), t$1 = [], n2.some(function(n3) {
      var l2, u2, i2, t2, r2, o2;
      n3.__d && (r2 = (t2 = (l2 = n3).__v).__e, (o2 = l2.__P) && (u2 = [], (i2 = a$1({}, t2)).__v = t2.__v + 1, j$2(o2, t2, i2, l2.__n, o2.ownerSVGElement !== void 0, t2.__h != null ? [r2] : null, u2, r2 == null ? k$1(t2) : r2, t2.__h), z$1(u2, t2), t2.__e != r2 && b$1(t2)));
    });
}
function w$2(n2, l2, u2, i2, t2, r2, o2, f2, s2, a2) {
  var h2, v2, p2, _2, b2, m2, g2, w2 = i2 && i2.__k || c$1, A2 = w2.length;
  for (u2.__k = [], h2 = 0; h2 < l2.length; h2++)
    if ((_2 = u2.__k[h2] = (_2 = l2[h2]) == null || typeof _2 == "boolean" ? null : typeof _2 == "string" || typeof _2 == "number" || typeof _2 == "bigint" ? y$1(null, _2, null, null, _2) : Array.isArray(_2) ? y$1(d, { children: _2 }, null, null, null) : _2.__b > 0 ? y$1(_2.type, _2.props, _2.key, null, _2.__v) : _2) != null) {
      if (_2.__ = u2, _2.__b = u2.__b + 1, (p2 = w2[h2]) === null || p2 && _2.key == p2.key && _2.type === p2.type)
        w2[h2] = void 0;
      else
        for (v2 = 0; v2 < A2; v2++) {
          if ((p2 = w2[v2]) && _2.key == p2.key && _2.type === p2.type) {
            w2[v2] = void 0;
            break;
          }
          p2 = null;
        }
      j$2(n2, _2, p2 = p2 || e$1, t2, r2, o2, f2, s2, a2), b2 = _2.__e, (v2 = _2.ref) && p2.ref != v2 && (g2 || (g2 = []), p2.ref && g2.push(p2.ref, null, _2), g2.push(v2, _2.__c || b2, _2)), b2 != null ? (m2 == null && (m2 = b2), typeof _2.type == "function" && _2.__k === p2.__k ? _2.__d = s2 = x$2(_2, s2, n2) : s2 = P$1(n2, _2, p2, w2, b2, s2), typeof u2.type == "function" && (u2.__d = s2)) : s2 && p2.__e == s2 && s2.parentNode != n2 && (s2 = k$1(p2));
    }
  for (u2.__e = m2, h2 = A2; h2--; )
    w2[h2] != null && (typeof u2.type == "function" && w2[h2].__e != null && w2[h2].__e == u2.__d && (u2.__d = k$1(i2, h2 + 1)), N(w2[h2], w2[h2]));
  if (g2)
    for (h2 = 0; h2 < g2.length; h2++)
      M$1(g2[h2], g2[++h2], g2[++h2]);
}
function x$2(n2, l2, u2) {
  for (var i2, t2 = n2.__k, r2 = 0; t2 && r2 < t2.length; r2++)
    (i2 = t2[r2]) && (i2.__ = n2, l2 = typeof i2.type == "function" ? x$2(i2, l2, u2) : P$1(u2, i2, i2, t2, i2.__e, l2));
  return l2;
}
function A$2(n2, l2) {
  return l2 = l2 || [], n2 == null || typeof n2 == "boolean" || (Array.isArray(n2) ? n2.some(function(n3) {
    A$2(n3, l2);
  }) : l2.push(n2)), l2;
}
function P$1(n2, l2, u2, i2, t2, r2) {
  var o2, f2, e2;
  if (l2.__d !== void 0)
    o2 = l2.__d, l2.__d = void 0;
  else if (u2 == null || t2 != r2 || t2.parentNode == null)
    n:
      if (r2 == null || r2.parentNode !== n2)
        n2.appendChild(t2), o2 = null;
      else {
        for (f2 = r2, e2 = 0; (f2 = f2.nextSibling) && e2 < i2.length; e2 += 2)
          if (f2 == t2)
            break n;
        n2.insertBefore(t2, r2), o2 = r2;
      }
  return o2 !== void 0 ? o2 : t2.nextSibling;
}
function C$1(n2, l2, u2, i2, t2) {
  var r2;
  for (r2 in u2)
    r2 === "children" || r2 === "key" || r2 in l2 || H(n2, r2, null, u2[r2], i2);
  for (r2 in l2)
    t2 && typeof l2[r2] != "function" || r2 === "children" || r2 === "key" || r2 === "value" || r2 === "checked" || u2[r2] === l2[r2] || H(n2, r2, l2[r2], u2[r2], i2);
}
function $$1(n2, l2, u2) {
  l2[0] === "-" ? n2.setProperty(l2, u2) : n2[l2] = u2 == null ? "" : typeof u2 != "number" || s$1.test(l2) ? u2 : u2 + "px";
}
function H(n2, l2, u2, i2, t2) {
  var r2;
  n:
    if (l2 === "style")
      if (typeof u2 == "string")
        n2.style.cssText = u2;
      else {
        if (typeof i2 == "string" && (n2.style.cssText = i2 = ""), i2)
          for (l2 in i2)
            u2 && l2 in u2 || $$1(n2.style, l2, "");
        if (u2)
          for (l2 in u2)
            i2 && u2[l2] === i2[l2] || $$1(n2.style, l2, u2[l2]);
      }
    else if (l2[0] === "o" && l2[1] === "n")
      r2 = l2 !== (l2 = l2.replace(/Capture$/, "")), l2 = l2.toLowerCase() in n2 ? l2.toLowerCase().slice(2) : l2.slice(2), n2.l || (n2.l = {}), n2.l[l2 + r2] = u2, u2 ? i2 || n2.addEventListener(l2, r2 ? T$1 : I, r2) : n2.removeEventListener(l2, r2 ? T$1 : I, r2);
    else if (l2 !== "dangerouslySetInnerHTML") {
      if (t2)
        l2 = l2.replace(/xlink[H:h]/, "h").replace(/sName$/, "s");
      else if (l2 !== "href" && l2 !== "list" && l2 !== "form" && l2 !== "tabIndex" && l2 !== "download" && l2 in n2)
        try {
          n2[l2] = u2 == null ? "" : u2;
          break n;
        } catch (n3) {
        }
      typeof u2 == "function" || (u2 != null && (u2 !== false || l2[0] === "a" && l2[1] === "r") ? n2.setAttribute(l2, u2) : n2.removeAttribute(l2));
    }
}
function I(n2) {
  this.l[n2.type + false](l$1.event ? l$1.event(n2) : n2);
}
function T$1(n2) {
  this.l[n2.type + true](l$1.event ? l$1.event(n2) : n2);
}
function j$2(n2, u2, i2, t2, r2, o2, f2, e2, c2) {
  var s2, h2, v2, y2, p2, k2, b2, m2, g2, x2, A2, P2 = u2.type;
  if (u2.constructor !== void 0)
    return null;
  i2.__h != null && (c2 = i2.__h, e2 = u2.__e = i2.__e, u2.__h = null, o2 = [e2]), (s2 = l$1.__b) && s2(u2);
  try {
    n:
      if (typeof P2 == "function") {
        if (m2 = u2.props, g2 = (s2 = P2.contextType) && t2[s2.__c], x2 = s2 ? g2 ? g2.props.value : s2.__ : t2, i2.__c ? b2 = (h2 = u2.__c = i2.__c).__ = h2.__E : ("prototype" in P2 && P2.prototype.render ? u2.__c = h2 = new P2(m2, x2) : (u2.__c = h2 = new _$1(m2, x2), h2.constructor = P2, h2.render = O$1), g2 && g2.sub(h2), h2.props = m2, h2.state || (h2.state = {}), h2.context = x2, h2.__n = t2, v2 = h2.__d = true, h2.__h = []), h2.__s == null && (h2.__s = h2.state), P2.getDerivedStateFromProps != null && (h2.__s == h2.state && (h2.__s = a$1({}, h2.__s)), a$1(h2.__s, P2.getDerivedStateFromProps(m2, h2.__s))), y2 = h2.props, p2 = h2.state, v2)
          P2.getDerivedStateFromProps == null && h2.componentWillMount != null && h2.componentWillMount(), h2.componentDidMount != null && h2.__h.push(h2.componentDidMount);
        else {
          if (P2.getDerivedStateFromProps == null && m2 !== y2 && h2.componentWillReceiveProps != null && h2.componentWillReceiveProps(m2, x2), !h2.__e && h2.shouldComponentUpdate != null && h2.shouldComponentUpdate(m2, h2.__s, x2) === false || u2.__v === i2.__v) {
            h2.props = m2, h2.state = h2.__s, u2.__v !== i2.__v && (h2.__d = false), h2.__v = u2, u2.__e = i2.__e, u2.__k = i2.__k, u2.__k.forEach(function(n3) {
              n3 && (n3.__ = u2);
            }), h2.__h.length && f2.push(h2);
            break n;
          }
          h2.componentWillUpdate != null && h2.componentWillUpdate(m2, h2.__s, x2), h2.componentDidUpdate != null && h2.__h.push(function() {
            h2.componentDidUpdate(y2, p2, k2);
          });
        }
        h2.context = x2, h2.props = m2, h2.state = h2.__s, (s2 = l$1.__r) && s2(u2), h2.__d = false, h2.__v = u2, h2.__P = n2, s2 = h2.render(h2.props, h2.state, h2.context), h2.state = h2.__s, h2.getChildContext != null && (t2 = a$1(a$1({}, t2), h2.getChildContext())), v2 || h2.getSnapshotBeforeUpdate == null || (k2 = h2.getSnapshotBeforeUpdate(y2, p2)), A2 = s2 != null && s2.type === d && s2.key == null ? s2.props.children : s2, w$2(n2, Array.isArray(A2) ? A2 : [A2], u2, i2, t2, r2, o2, f2, e2, c2), h2.base = u2.__e, u2.__h = null, h2.__h.length && f2.push(h2), b2 && (h2.__E = h2.__ = null), h2.__e = false;
      } else
        o2 == null && u2.__v === i2.__v ? (u2.__k = i2.__k, u2.__e = i2.__e) : u2.__e = L$1(i2.__e, u2, i2, t2, r2, o2, f2, c2);
    (s2 = l$1.diffed) && s2(u2);
  } catch (n3) {
    u2.__v = null, (c2 || o2 != null) && (u2.__e = e2, u2.__h = !!c2, o2[o2.indexOf(e2)] = null), l$1.__e(n3, u2, i2);
  }
}
function z$1(n2, u2) {
  l$1.__c && l$1.__c(u2, n2), n2.some(function(u3) {
    try {
      n2 = u3.__h, u3.__h = [], n2.some(function(n3) {
        n3.call(u3);
      });
    } catch (n3) {
      l$1.__e(n3, u3.__v);
    }
  });
}
function L$1(l2, u2, i2, t2, r2, o2, f2, c2) {
  var s2, a2, v2, y2 = i2.props, p2 = u2.props, d2 = u2.type, _2 = 0;
  if (d2 === "svg" && (r2 = true), o2 != null) {
    for (; _2 < o2.length; _2++)
      if ((s2 = o2[_2]) && (s2 === l2 || (d2 ? s2.localName == d2 : s2.nodeType == 3))) {
        l2 = s2, o2[_2] = null;
        break;
      }
  }
  if (l2 == null) {
    if (d2 === null)
      return document.createTextNode(p2);
    l2 = r2 ? document.createElementNS("http://www.w3.org/2000/svg", d2) : document.createElement(d2, p2.is && p2), o2 = null, c2 = false;
  }
  if (d2 === null)
    y2 === p2 || c2 && l2.data === p2 || (l2.data = p2);
  else {
    if (o2 = o2 && n.call(l2.childNodes), a2 = (y2 = i2.props || e$1).dangerouslySetInnerHTML, v2 = p2.dangerouslySetInnerHTML, !c2) {
      if (o2 != null)
        for (y2 = {}, _2 = 0; _2 < l2.attributes.length; _2++)
          y2[l2.attributes[_2].name] = l2.attributes[_2].value;
      (v2 || a2) && (v2 && (a2 && v2.__html == a2.__html || v2.__html === l2.innerHTML) || (l2.innerHTML = v2 && v2.__html || ""));
    }
    if (C$1(l2, p2, y2, r2, c2), v2)
      u2.__k = [];
    else if (_2 = u2.props.children, w$2(l2, Array.isArray(_2) ? _2 : [_2], u2, i2, t2, r2 && d2 !== "foreignObject", o2, f2, o2 ? o2[0] : i2.__k && k$1(i2, 0), c2), o2 != null)
      for (_2 = o2.length; _2--; )
        o2[_2] != null && h$1(o2[_2]);
    c2 || ("value" in p2 && (_2 = p2.value) !== void 0 && (_2 !== l2.value || d2 === "progress" && !_2) && H(l2, "value", _2, y2.value, false), "checked" in p2 && (_2 = p2.checked) !== void 0 && _2 !== l2.checked && H(l2, "checked", _2, y2.checked, false));
  }
  return l2;
}
function M$1(n2, u2, i2) {
  try {
    typeof n2 == "function" ? n2(u2) : n2.current = u2;
  } catch (n3) {
    l$1.__e(n3, i2);
  }
}
function N(n2, u2, i2) {
  var t2, r2;
  if (l$1.unmount && l$1.unmount(n2), (t2 = n2.ref) && (t2.current && t2.current !== n2.__e || M$1(t2, null, u2)), (t2 = n2.__c) != null) {
    if (t2.componentWillUnmount)
      try {
        t2.componentWillUnmount();
      } catch (n3) {
        l$1.__e(n3, u2);
      }
    t2.base = t2.__P = null;
  }
  if (t2 = n2.__k)
    for (r2 = 0; r2 < t2.length; r2++)
      t2[r2] && N(t2[r2], u2, typeof n2.type != "function");
  i2 || n2.__e == null || h$1(n2.__e), n2.__e = n2.__d = void 0;
}
function O$1(n2, l2, u2) {
  return this.constructor(n2, u2);
}
function S$1(u2, i2, t2) {
  var r2, o2, f2;
  l$1.__ && l$1.__(u2, i2), o2 = (r2 = typeof t2 == "function") ? null : t2 && t2.__k || i2.__k, f2 = [], j$2(i2, u2 = (!r2 && t2 || i2).__k = v$1(d, null, [u2]), o2 || e$1, e$1, i2.ownerSVGElement !== void 0, !r2 && t2 ? [t2] : o2 ? null : i2.firstChild ? n.call(i2.childNodes) : null, f2, !r2 && t2 ? t2 : o2 ? o2.__e : i2.firstChild, r2), z$1(f2, u2);
}
n = c$1.slice, l$1 = { __e: function(n2, l2) {
  for (var u2, i2, t2; l2 = l2.__; )
    if ((u2 = l2.__c) && !u2.__)
      try {
        if ((i2 = u2.constructor) && i2.getDerivedStateFromError != null && (u2.setState(i2.getDerivedStateFromError(n2)), t2 = u2.__d), u2.componentDidCatch != null && (u2.componentDidCatch(n2), t2 = u2.__d), t2)
          return u2.__E = u2;
      } catch (l3) {
        n2 = l3;
      }
  throw n2;
} }, u$1 = 0, _$1.prototype.setState = function(n2, l2) {
  var u2;
  u2 = this.__s != null && this.__s !== this.state ? this.__s : this.__s = a$1({}, this.state), typeof n2 == "function" && (n2 = n2(a$1({}, u2), this.props)), n2 && a$1(u2, n2), n2 != null && this.__v && (l2 && this.__h.push(l2), m$1(this));
}, _$1.prototype.forceUpdate = function(n2) {
  this.__v && (this.__e = true, n2 && this.__h.push(n2), m$1(this));
}, _$1.prototype.render = d, t$1 = [], r$1 = typeof Promise == "function" ? Promise.prototype.then.bind(Promise.resolve()) : setTimeout, g$1.__r = 0;
var t, u, r, o = 0, i = [], c = l$1.__b, f = l$1.__r, e = l$1.diffed, a = l$1.__c, v = l$1.unmount;
function m(t2, r2) {
  l$1.__h && l$1.__h(u, t2, o || r2), o = 0;
  var i2 = u.__H || (u.__H = { __: [], __h: [] });
  return t2 >= i2.__.length && i2.__.push({}), i2.__[t2];
}
function l(n2) {
  return o = 1, p(w$1, n2);
}
function p(n2, r2, o2) {
  var i2 = m(t++, 2);
  return i2.t = n2, i2.__c || (i2.__ = [o2 ? o2(r2) : w$1(void 0, r2), function(n3) {
    var t2 = i2.t(i2.__[0], n3);
    i2.__[0] !== t2 && (i2.__ = [t2, i2.__[1]], i2.__c.setState({}));
  }], i2.__c = u), i2.__;
}
function y(r2, o2) {
  var i2 = m(t++, 3);
  !l$1.__s && k(i2.__H, o2) && (i2.__ = r2, i2.__H = o2, u.__H.__h.push(i2));
}
function h(r2, o2) {
  var i2 = m(t++, 4);
  !l$1.__s && k(i2.__H, o2) && (i2.__ = r2, i2.__H = o2, u.__h.push(i2));
}
function s(n2) {
  return o = 5, A$1(function() {
    return { current: n2 };
  }, []);
}
function _(n2, t2, u2) {
  o = 6, h(function() {
    typeof n2 == "function" ? n2(t2()) : n2 && (n2.current = t2());
  }, u2 == null ? u2 : u2.concat(n2));
}
function A$1(n2, u2) {
  var r2 = m(t++, 7);
  return k(r2.__H, u2) && (r2.__ = n2(), r2.__H = u2, r2.__h = n2), r2.__;
}
function F(n2, t2) {
  return o = 8, A$1(function() {
    return n2;
  }, t2);
}
function x$1() {
  i.forEach(function(t2) {
    if (t2.__P)
      try {
        t2.__H.__h.forEach(g), t2.__H.__h.forEach(j$1), t2.__H.__h = [];
      } catch (u2) {
        t2.__H.__h = [], l$1.__e(u2, t2.__v);
      }
  }), i = [];
}
l$1.__b = function(n2) {
  u = null, c && c(n2);
}, l$1.__r = function(n2) {
  f && f(n2), t = 0;
  var r2 = (u = n2.__c).__H;
  r2 && (r2.__h.forEach(g), r2.__h.forEach(j$1), r2.__h = []);
}, l$1.diffed = function(t2) {
  e && e(t2);
  var o2 = t2.__c;
  o2 && o2.__H && o2.__H.__h.length && (i.push(o2) !== 1 && r === l$1.requestAnimationFrame || ((r = l$1.requestAnimationFrame) || function(n2) {
    var t3, u2 = function() {
      clearTimeout(r2), b && cancelAnimationFrame(t3), setTimeout(n2);
    }, r2 = setTimeout(u2, 100);
    b && (t3 = requestAnimationFrame(u2));
  })(x$1)), u = null;
}, l$1.__c = function(t2, u2) {
  u2.some(function(t3) {
    try {
      t3.__h.forEach(g), t3.__h = t3.__h.filter(function(n2) {
        return !n2.__ || j$1(n2);
      });
    } catch (r2) {
      u2.some(function(n2) {
        n2.__h && (n2.__h = []);
      }), u2 = [], l$1.__e(r2, t3.__v);
    }
  }), a && a(t2, u2);
}, l$1.unmount = function(t2) {
  v && v(t2);
  var u2 = t2.__c;
  if (u2 && u2.__H)
    try {
      u2.__H.__.forEach(g);
    } catch (t3) {
      l$1.__e(t3, u2.__v);
    }
};
var b = typeof requestAnimationFrame == "function";
function g(n2) {
  var t2 = u;
  typeof n2.__c == "function" && n2.__c(), u = t2;
}
function j$1(n2) {
  var t2 = u;
  n2.__c = n2.__(), u = t2;
}
function k(n2, t2) {
  return !n2 || n2.length !== t2.length || t2.some(function(t3, u2) {
    return t3 !== n2[u2];
  });
}
function w$1(n2, t2) {
  return typeof t2 == "function" ? t2(n2) : t2;
}
function S(n2, t2) {
  for (var e2 in t2)
    n2[e2] = t2[e2];
  return n2;
}
function C(n2, t2) {
  for (var e2 in n2)
    if (e2 !== "__source" && !(e2 in t2))
      return true;
  for (var r2 in t2)
    if (r2 !== "__source" && n2[r2] !== t2[r2])
      return true;
  return false;
}
function E(n2) {
  this.props = n2;
}
(E.prototype = new _$1()).isPureReactComponent = true, E.prototype.shouldComponentUpdate = function(n2, t2) {
  return C(this.props, n2) || C(this.state, t2);
};
var w = l$1.__b;
l$1.__b = function(n2) {
  n2.type && n2.type.__f && n2.ref && (n2.props.ref = n2.ref, n2.ref = null), w && w(n2);
};
var R = typeof Symbol != "undefined" && Symbol.for && Symbol.for("react.forward_ref") || 3911;
function x(n2) {
  function t2(t3, e2) {
    var r2 = S({}, t3);
    return delete r2.ref, n2(r2, (e2 = t3.ref || e2) && (typeof e2 != "object" || "current" in e2) ? e2 : null);
  }
  return t2.$$typeof = R, t2.render = t2, t2.prototype.isReactComponent = t2.__f = true, t2.displayName = "ForwardRef(" + (n2.displayName || n2.name) + ")", t2;
}
var A = l$1.__e;
l$1.__e = function(n2, t2, e2) {
  if (n2.then) {
    for (var r2, u2 = t2; u2 = u2.__; )
      if ((r2 = u2.__c) && r2.__c)
        return t2.__e == null && (t2.__e = e2.__e, t2.__k = e2.__k), r2.__c(n2, t2);
  }
  A(n2, t2, e2);
};
var O = l$1.unmount;
function L() {
  this.__u = 0, this.t = null, this.__b = null;
}
function U(n2) {
  var t2 = n2.__.__c;
  return t2 && t2.__e && t2.__e(n2);
}
function M() {
  this.u = null, this.o = null;
}
l$1.unmount = function(n2) {
  var t2 = n2.__c;
  t2 && t2.__R && t2.__R(), t2 && n2.__h === true && (n2.type = null), O && O(n2);
}, (L.prototype = new _$1()).__c = function(n2, t2) {
  var e2 = t2.__c, r2 = this;
  r2.t == null && (r2.t = []), r2.t.push(e2);
  var u2 = U(r2.__v), o2 = false, i2 = function() {
    o2 || (o2 = true, e2.__R = null, u2 ? u2(l2) : l2());
  };
  e2.__R = i2;
  var l2 = function() {
    if (!--r2.__u) {
      if (r2.state.__e) {
        var n3 = r2.state.__e;
        r2.__v.__k[0] = function n4(t4, e3, r3) {
          return t4 && (t4.__v = null, t4.__k = t4.__k && t4.__k.map(function(t5) {
            return n4(t5, e3, r3);
          }), t4.__c && t4.__c.__P === e3 && (t4.__e && r3.insertBefore(t4.__e, t4.__d), t4.__c.__e = true, t4.__c.__P = r3)), t4;
        }(n3, n3.__c.__P, n3.__c.__O);
      }
      var t3;
      for (r2.setState({ __e: r2.__b = null }); t3 = r2.t.pop(); )
        t3.forceUpdate();
    }
  }, c2 = t2.__h === true;
  r2.__u++ || c2 || r2.setState({ __e: r2.__b = r2.__v.__k[0] }), n2.then(i2, i2);
}, L.prototype.componentWillUnmount = function() {
  this.t = [];
}, L.prototype.render = function(n2, t2) {
  if (this.__b) {
    if (this.__v.__k) {
      var e2 = document.createElement("div"), r2 = this.__v.__k[0].__c;
      this.__v.__k[0] = function n3(t3, e3, r3) {
        return t3 && (t3.__c && t3.__c.__H && (t3.__c.__H.__.forEach(function(n4) {
          typeof n4.__c == "function" && n4.__c();
        }), t3.__c.__H = null), (t3 = S({}, t3)).__c != null && (t3.__c.__P === r3 && (t3.__c.__P = e3), t3.__c = null), t3.__k = t3.__k && t3.__k.map(function(t4) {
          return n3(t4, e3, r3);
        })), t3;
      }(this.__b, e2, r2.__O = r2.__P);
    }
    this.__b = null;
  }
  var u2 = t2.__e && v$1(d, null, n2.fallback);
  return u2 && (u2.__h = null), [v$1(d, null, t2.__e ? null : n2.children), u2];
};
var T = function(n2, t2, e2) {
  if (++e2[1] === e2[0] && n2.o.delete(t2), n2.props.revealOrder && (n2.props.revealOrder[0] !== "t" || !n2.o.size))
    for (e2 = n2.u; e2; ) {
      for (; e2.length > 3; )
        e2.pop()();
      if (e2[1] < e2[0])
        break;
      n2.u = e2 = e2[2];
    }
};
(M.prototype = new _$1()).__e = function(n2) {
  var t2 = this, e2 = U(t2.__v), r2 = t2.o.get(n2);
  return r2[0]++, function(u2) {
    var o2 = function() {
      t2.props.revealOrder ? (r2.push(u2), T(t2, n2, r2)) : u2();
    };
    e2 ? e2(o2) : o2();
  };
}, M.prototype.render = function(n2) {
  this.u = null, this.o = new Map();
  var t2 = A$2(n2.children);
  n2.revealOrder && n2.revealOrder[0] === "b" && t2.reverse();
  for (var e2 = t2.length; e2--; )
    this.o.set(t2[e2], this.u = [1, 0, this.u]);
  return n2.children;
}, M.prototype.componentDidUpdate = M.prototype.componentDidMount = function() {
  var n2 = this;
  this.o.forEach(function(t2, e2) {
    T(n2, e2, t2);
  });
};
var j = typeof Symbol != "undefined" && Symbol.for && Symbol.for("react.element") || 60103, P = /^(?:accent|alignment|arabic|baseline|cap|clip(?!PathU)|color|dominant|fill|flood|font|glyph(?!R)|horiz|marker(?!H|W|U)|overline|paint|stop|strikethrough|stroke|text(?!L)|underline|unicode|units|v|vector|vert|word|writing|x(?!C))[A-Z]/, V = typeof document != "undefined", z = function(n2) {
  return (typeof Symbol != "undefined" && typeof Symbol() == "symbol" ? /fil|che|rad/i : /fil|che|ra/i).test(n2);
};
_$1.prototype.isReactComponent = {}, ["componentWillMount", "componentWillReceiveProps", "componentWillUpdate"].forEach(function(n2) {
  Object.defineProperty(_$1.prototype, n2, { configurable: true, get: function() {
    return this["UNSAFE_" + n2];
  }, set: function(t2) {
    Object.defineProperty(this, n2, { configurable: true, writable: true, value: t2 });
  } });
});
var Z = l$1.event;
function Y() {
}
function $() {
  return this.cancelBubble;
}
function q() {
  return this.defaultPrevented;
}
l$1.event = function(n2) {
  return Z && (n2 = Z(n2)), n2.persist = Y, n2.isPropagationStopped = $, n2.isDefaultPrevented = q, n2.nativeEvent = n2;
};
var J = { configurable: true, get: function() {
  return this.class;
} }, K = l$1.vnode;
l$1.vnode = function(n2) {
  var t2 = n2.type, e2 = n2.props, r2 = e2;
  if (typeof t2 == "string") {
    var u2 = t2.indexOf("-") === -1;
    for (var o2 in r2 = {}, e2) {
      var i2 = e2[o2];
      V && o2 === "children" && t2 === "noscript" || o2 === "value" && "defaultValue" in e2 && i2 == null || (o2 === "defaultValue" && "value" in e2 && e2.value == null ? o2 = "value" : o2 === "download" && i2 === true ? i2 = "" : /ondoubleclick/i.test(o2) ? o2 = "ondblclick" : /^onchange(textarea|input)/i.test(o2 + t2) && !z(e2.type) ? o2 = "oninput" : /^on(Ani|Tra|Tou|BeforeInp)/.test(o2) ? o2 = o2.toLowerCase() : u2 && P.test(o2) ? o2 = o2.replace(/[A-Z0-9]/, "-$&").toLowerCase() : i2 === null && (i2 = void 0), r2[o2] = i2);
    }
    t2 == "select" && r2.multiple && Array.isArray(r2.value) && (r2.value = A$2(e2.children).forEach(function(n3) {
      n3.props.selected = r2.value.indexOf(n3.props.value) != -1;
    })), t2 == "select" && r2.defaultValue != null && (r2.value = A$2(e2.children).forEach(function(n3) {
      n3.props.selected = r2.multiple ? r2.defaultValue.indexOf(n3.props.value) != -1 : r2.defaultValue == n3.props.value;
    })), n2.props = r2;
  }
  t2 && e2.class != e2.className && (J.enumerable = "className" in e2, e2.className != null && (r2.class = e2.className), Object.defineProperty(r2, "className", J)), n2.$$typeof = j, K && K(n2);
};
var Q = l$1.__r;
l$1.__r = function(n2) {
  Q && Q(n2);
};
var commonjsGlobal = typeof globalThis !== "undefined" ? globalThis : typeof window !== "undefined" ? window : typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : {};
function isObject$3(value) {
  var type = typeof value;
  return value != null && (type == "object" || type == "function");
}
var isObject_1 = isObject$3;
var freeGlobal$1 = typeof commonjsGlobal == "object" && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;
var _freeGlobal = freeGlobal$1;
var freeGlobal = _freeGlobal;
var freeSelf = typeof self == "object" && self && self.Object === Object && self;
var root$2 = freeGlobal || freeSelf || Function("return this")();
var _root = root$2;
var root$1 = _root;
var now$1 = function() {
  return root$1.Date.now();
};
var now_1 = now$1;
var reWhitespace = /\s/;
function trimmedEndIndex$1(string) {
  var index = string.length;
  while (index-- && reWhitespace.test(string.charAt(index))) {
  }
  return index;
}
var _trimmedEndIndex = trimmedEndIndex$1;
var trimmedEndIndex = _trimmedEndIndex;
var reTrimStart = /^\s+/;
function baseTrim$1(string) {
  return string ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, "") : string;
}
var _baseTrim = baseTrim$1;
var root = _root;
var Symbol$3 = root.Symbol;
var _Symbol = Symbol$3;
var Symbol$2 = _Symbol;
var objectProto$1 = Object.prototype;
var hasOwnProperty = objectProto$1.hasOwnProperty;
var nativeObjectToString$1 = objectProto$1.toString;
var symToStringTag$1 = Symbol$2 ? Symbol$2.toStringTag : void 0;
function getRawTag$1(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag$1), tag = value[symToStringTag$1];
  try {
    value[symToStringTag$1] = void 0;
    var unmasked = true;
  } catch (e2) {
  }
  var result = nativeObjectToString$1.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag$1] = tag;
    } else {
      delete value[symToStringTag$1];
    }
  }
  return result;
}
var _getRawTag = getRawTag$1;
var objectProto = Object.prototype;
var nativeObjectToString = objectProto.toString;
function objectToString$1(value) {
  return nativeObjectToString.call(value);
}
var _objectToString = objectToString$1;
var Symbol$1 = _Symbol, getRawTag = _getRawTag, objectToString = _objectToString;
var nullTag = "[object Null]", undefinedTag = "[object Undefined]";
var symToStringTag = Symbol$1 ? Symbol$1.toStringTag : void 0;
function baseGetTag$1(value) {
  if (value == null) {
    return value === void 0 ? undefinedTag : nullTag;
  }
  return symToStringTag && symToStringTag in Object(value) ? getRawTag(value) : objectToString(value);
}
var _baseGetTag = baseGetTag$1;
function isObjectLike$1(value) {
  return value != null && typeof value == "object";
}
var isObjectLike_1 = isObjectLike$1;
var baseGetTag = _baseGetTag, isObjectLike = isObjectLike_1;
var symbolTag = "[object Symbol]";
function isSymbol$1(value) {
  return typeof value == "symbol" || isObjectLike(value) && baseGetTag(value) == symbolTag;
}
var isSymbol_1 = isSymbol$1;
var baseTrim = _baseTrim, isObject$2 = isObject_1, isSymbol = isSymbol_1;
var NAN = 0 / 0;
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
var reIsBinary = /^0b[01]+$/i;
var reIsOctal = /^0o[0-7]+$/i;
var freeParseInt = parseInt;
function toNumber$1(value) {
  if (typeof value == "number") {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject$2(value)) {
    var other = typeof value.valueOf == "function" ? value.valueOf() : value;
    value = isObject$2(other) ? other + "" : other;
  }
  if (typeof value != "string") {
    return value === 0 ? value : +value;
  }
  value = baseTrim(value);
  var isBinary = reIsBinary.test(value);
  return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN : +value;
}
var toNumber_1 = toNumber$1;
var isObject$1 = isObject_1, now = now_1, toNumber = toNumber_1;
var FUNC_ERROR_TEXT$1 = "Expected a function";
var nativeMax = Math.max, nativeMin = Math.min;
function debounce$1(func, wait, options) {
  var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
  if (typeof func != "function") {
    throw new TypeError(FUNC_ERROR_TEXT$1);
  }
  wait = toNumber(wait) || 0;
  if (isObject$1(options)) {
    leading = !!options.leading;
    maxing = "maxWait" in options;
    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
    trailing = "trailing" in options ? !!options.trailing : trailing;
  }
  function invokeFunc(time) {
    var args = lastArgs, thisArg = lastThis;
    lastArgs = lastThis = void 0;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }
  function leadingEdge(time) {
    lastInvokeTime = time;
    timerId = setTimeout(timerExpired, wait);
    return leading ? invokeFunc(time) : result;
  }
  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, timeWaiting = wait - timeSinceLastCall;
    return maxing ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
  }
  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
    return lastCallTime === void 0 || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
  }
  function timerExpired() {
    var time = now();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    timerId = setTimeout(timerExpired, remainingWait(time));
  }
  function trailingEdge(time) {
    timerId = void 0;
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = void 0;
    return result;
  }
  function cancel() {
    if (timerId !== void 0) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = void 0;
  }
  function flush() {
    return timerId === void 0 ? result : trailingEdge(now());
  }
  function debounced() {
    var time = now(), isInvoking = shouldInvoke(time);
    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;
    if (isInvoking) {
      if (timerId === void 0) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        clearTimeout(timerId);
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === void 0) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}
var debounce_1 = debounce$1;
var debounce = debounce_1, isObject = isObject_1;
var FUNC_ERROR_TEXT = "Expected a function";
function throttle(func, wait, options) {
  var leading = true, trailing = true;
  if (typeof func != "function") {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  if (isObject(options)) {
    leading = "leading" in options ? !!options.leading : leading;
    trailing = "trailing" in options ? !!options.trailing : trailing;
  }
  return debounce(func, wait, {
    "leading": leading,
    "maxWait": wait,
    "trailing": trailing
  });
}
var throttle_1 = throttle;
function request(option) {
  return new Promise((resolve, reject) => {
    const xhr = new XMLHttpRequest();
    let url = option.url;
    if (option.params) {
      url += "?";
      Object.keys(option.params).forEach((key, index) => {
        url += `${key}=${option.params[key]}`;
        if (index < Object.keys(option.params).length - 1) {
          url += "&";
        }
      });
    }
    xhr.open("GET", url);
    xhr.onload = () => {
      if (xhr.status === 200) {
        try {
          resolve(JSON.parse(xhr.responseText));
        } catch (e2) {
          reject(e2);
        }
      } else {
        reject(xhr.statusText);
      }
    };
    xhr.onerror = () => {
      reject(xhr.statusText);
    };
    xhr.send();
  });
}
const geocoderUrl = "https://api.tianditu.gov.cn/geocoder";
const searchUrl = "https://api.tianditu.gov.cn/v2/search";
const adminCode = 156430100;
const getGeocodeInfo = (point, tk) => __async(this, null, function* () {
  try {
    const data = yield request({
      url: geocoderUrl,
      params: {
        postStr: `{"lon": ${point[1]},"lat":${point[0]},'ver':1}`,
        type: "geocode",
        tk
      }
    });
    if (+data.status === 0) {
      return data.result;
    }
  } catch (e2) {
  }
  return null;
});
const queryPoiListByKeywordAndAdminCode = (keyword, tk, specifyAdminCode) => __async(this, null, function* () {
  try {
    const data = yield request({
      url: searchUrl,
      params: {
        postStr: `{"keyWord":"${keyword}","queryType":12,"start":0,"count":10,"specify":"${specifyAdminCode}"}`,
        queryType: "7",
        tk,
        show: "1"
      }
    });
    if (data.resultType === 1 && +data.count > 0) {
      return data.pois.filter((p2) => p2.lonlat !== "0.000000,0.000000");
    }
  } catch (e2) {
  }
  return [];
});
let centerCache = null;
let cityCode = null;
const queryPoiListByKeyword = (keyword, center, tk) => __async(this, null, function* () {
  let code;
  if (cityCode === null || centerCache === null || center[0] !== centerCache[0] || center[1] !== centerCache[1]) {
    centerCache = center;
    const res = yield getGeocodeInfo(center, tk);
    if (res) {
      code = cityCode = +res.addressComponent.city_code;
    } else {
      code = cityCode = adminCode;
    }
  } else {
    code = cityCode;
  }
  return yield queryPoiListByKeywordAndAdminCode(keyword, tk, code);
});
var css = ".base-map-poi-list {\n  display: none;\n  background-color: #fff;\n}\n.base-map-poi-list.-active {\n  display: block;\n}\n.base-map-poi-item {\n  padding: 7px 5px 7px 20px;\n  border-bottom: 1px solid #eeeeee;\n}\n.base-map-poi-name {\n  font-size: 14px;\n  margin-right: 15px;\n}\n.base-map-poi-address {\n  font-size: 14px;\n  color: #999;\n}";
styleInject(css);
const Item = (props) => {
  const handleClick = () => {
    const latlon = props.lonlat.split(",");
    props.onPoiChange([+latlon[1], +latlon[0]]);
  };
  return /* @__PURE__ */ v$1("div", {
    class: "base-map-poi-item",
    onClick: handleClick
  }, /* @__PURE__ */ v$1("span", {
    class: "base-map-poi-icon"
  }), /* @__PURE__ */ v$1("span", {
    class: "base-map-poi-name"
  }, props.name), /* @__PURE__ */ v$1("span", {
    class: "base-map-poi-address"
  }, props.address));
};
const Poi = (props, ref) => {
  const [keyword, setKeyword] = l("");
  const [poiList, setPoiList] = l([]);
  const center = s(props.center);
  const currentKeyword = s("");
  _(ref, () => {
    return {
      setCenter(centerV) {
        center.current = centerV;
      }
    };
  });
  y(() => {
    (() => __async(this, null, function* () {
      if (keyword && keyword.length) {
        const tk = props.tk;
        const data = yield queryPoiListByKeyword(keyword, center.current, tk);
        if (keyword === currentKeyword.current) {
          const limitData = props.limit ? data.slice(0, props.limit) : data;
          setPoiList(limitData);
        }
      } else {
        if (keyword === currentKeyword.current) {
          setPoiList([]);
        }
      }
    }))();
  }, [keyword, currentKeyword, center]);
  const composing = s(false);
  const handleCompositionStart = () => {
    composing.current = true;
  };
  const handleCompositionEnd = (e2) => {
    composing.current = false;
    const value = e2.target.value;
    currentKeyword.current = value;
    setKeyword(value);
  };
  const handleChange = F(throttle_1((e2) => {
    if (composing.current)
      return;
    const value = e2.target.value;
    currentKeyword.current = value;
    setKeyword(value);
  }, 300), []);
  const [listIsActive, setListIsActive] = l(false);
  const isSelfClick = s(false);
  const handleFocus = () => {
    setListIsActive(true);
  };
  const handleSelfClick = () => {
    isSelfClick.current = true;
  };
  y(() => {
    const handleOtherClick = () => {
      if (!isSelfClick.current) {
        setListIsActive(false);
      }
      isSelfClick.current = false;
    };
    document.addEventListener("click", handleOtherClick);
    return () => {
      document.removeEventListener("click", handleOtherClick);
    };
  }, [isSelfClick]);
  return /* @__PURE__ */ v$1(d, null, /* @__PURE__ */ v$1("input", {
    class: "base-map-poi-input",
    oncompositionstart: handleCompositionStart,
    oncompositionend: handleCompositionEnd,
    onInput: handleChange,
    onFocus: handleFocus,
    onClick: handleSelfClick,
    type: "text",
    placeholder: "\u8F93\u5165\u5173\u952E\u5B57\u9009\u53D6\u5730\u70B9"
  }), /* @__PURE__ */ v$1("div", {
    class: `base-map-poi-list ${listIsActive ? "-active" : ""}`,
    onClick: handleSelfClick
  }, poiList.map((item) => /* @__PURE__ */ v$1(Item, __spreadProps(__spreadValues({}, item), {
    onPoiChange: (p2) => {
      props.onPoiChange(p2);
      setListIsActive(false);
    }
  })))));
};
const PoiW = x(Poi);
const poi = {
  container: document.createElement("div"),
  ref: p$1(),
  create(options) {
    const _a = options, { container } = _a, props = __objRest(_a, ["container"]);
    this.container = container;
    S$1(/* @__PURE__ */ v$1(PoiW, __spreadValues({
      ref: this.ref
    }, props)), container);
  },
  updateCenter(center) {
    this.ref.current.setCenter(center);
  },
  destroy() {
    if (this.container) {
      S$1(/* @__PURE__ */ v$1("span", null), this.container);
      this.container.remove();
    }
  }
};
var EVENT_TARGET;
(function(EVENT_TARGET2) {
  EVENT_TARGET2["baseMap"] = "";
  EVENT_TARGET2["map"] = "map";
  EVENT_TARGET2["title"] = "title";
  EVENT_TARGET2["polyline"] = "polyline";
  EVENT_TARGET2["polygon"] = "polygon";
})(EVENT_TARGET || (EVENT_TARGET = {}));
const drawInstanceEventTargetList = [
  EVENT_TARGET.title,
  EVENT_TARGET.polygon,
  EVENT_TARGET.polyline
];
class EventBind {
  constructor(drawMap) {
    this.eventMap = new Map();
    this.mapEventBindFlag = new Map();
    this.drawMap = drawMap;
  }
  setLeafletMapInstance(leafletMapInstance) {
    this.leafletMapInstance = leafletMapInstance;
  }
  eachDrawMap(callback) {
    Array.from(this.drawMap.keys()).forEach((id) => {
      const draw = this.drawMap.get(id);
      callback(draw, id);
    });
  }
  parseEventStr(event) {
    if (!event.includes(":")) {
      return {
        target: EVENT_TARGET.baseMap,
        eventName: event
      };
    } else {
      const [target, eventName] = event.split(":");
      if (Object.values(EVENT_TARGET).includes(target)) {
        return {
          target,
          eventName
        };
      } else {
        const supportedEvent = Object.values(EVENT_TARGET).filter((i2) => i2 !== EVENT_TARGET.baseMap).join(", ");
        throw new Error(`"${target}" is not a valid target, please check the event string, the target value must be one of these: ${supportedEvent} `);
      }
    }
  }
  drawInstanceHandleEvent(event, target, eventName, isBind) {
    const handle = (t2, d2) => {
      if (isBind) {
        if (t2.listens(eventName))
          return;
        t2.on(eventName, (e2) => {
          this.eventMap.get(event).forEach((cb) => cb({ id: d2.options.id, originEvent: e2 }));
        });
      } else {
        if (!t2.listens(eventName))
          return;
        t2.off(eventName);
      }
    };
    this.eachDrawMap((draw) => {
      if (target === EVENT_TARGET.title && draw.titleMarker) {
        handle(draw.titleMarker, draw);
      } else if (target === EVENT_TARGET.polygon && draw.polygon) {
        handle(draw.polygon, draw);
      } else if (target === EVENT_TARGET.polyline && draw.polyline) {
        handle(draw.polyline, draw);
      }
    });
  }
  on(event, callback) {
    const { target, eventName } = this.parseEventStr(event);
    if (!this.eventMap.has(event)) {
      this.eventMap.set(event, []);
    }
    if (callback !== void 0 && !this.eventMap.get(event).includes(callback)) {
      this.eventMap.get(event).push(callback);
    }
    if (this.eventMap.get(event).length > 0) {
      if (drawInstanceEventTargetList.includes(target)) {
        this.drawInstanceHandleEvent(event, target, eventName, true);
      } else if (target === EVENT_TARGET.map && this.mapEventBindFlag.get(event) === void 0 && this.leafletMapInstance !== void 0) {
        this.mapEventBindFlag.set(event, true);
        this.leafletMapInstance.on(eventName, (e2) => {
          this.eventMap.get(event).forEach((cb) => cb(e2));
        });
      }
    }
  }
  bindToNewTarget() {
    Array.from(this.eventMap.keys()).forEach((event) => {
      const { target, eventName } = this.parseEventStr(event);
      if (drawInstanceEventTargetList.includes(target)) {
        this.drawInstanceHandleEvent(event, target, eventName, true);
      }
    });
  }
  off(event, callback) {
    var _a;
    const { target, eventName } = this.parseEventStr(event);
    if (callback !== void 0) {
      if (this.eventMap.get(event).includes(callback)) {
        const index = (_a = this.eventMap.get(event)) == null ? void 0 : _a.findIndex((cb) => cb === callback);
        if (index !== void 0) {
          this.eventMap.get(event).splice(index, 1);
        }
      }
    } else {
      this.eventMap.set(event, []);
    }
    if (this.eventMap.get(event).length === 0) {
      if (drawInstanceEventTargetList.includes(target)) {
        this.drawInstanceHandleEvent(event, target, eventName, false);
      } else if (target === EVENT_TARGET.map && this.leafletMapInstance !== void 0) {
        this.mapEventBindFlag.set(event, false);
        this.leafletMapInstance.off(eventName);
      }
    }
  }
}
function getElementOffset(el) {
  const result = el.style.transform.match(/\((-?\d+)px,\s+(-?\d+)px/i);
  return {
    x: +result[1],
    y: +result[2]
  };
}
const getSnapshotByGraphicInfo = (options) => __async(this, null, function* () {
  let resolve;
  const result = new Promise((res) => {
    resolve = res;
  });
  const {
    graphicInfoList,
    width,
    height,
    TianDiTuKey,
    themeColor
  } = __spreadValues(__spreadValues({}, {
    width: 345,
    height: 172,
    themeColor: "#0097ff"
  }), options);
  const containerEl = document.createElement("div");
  containerEl.style.width = width + "px";
  containerEl.style.height = height + "px";
  containerEl.style.position = "fixed";
  containerEl.style.top = "0";
  containerEl.style.left = "0";
  containerEl.style.transform = "translate(-100%, -100%)";
  const dispose = () => {
    baseMap.destroy();
    document.body.removeChild(containerEl);
  };
  const handleResolve = (base64) => {
    resolve([null, base64]);
    dispose();
  };
  const handleReject = (err) => {
    resolve([err, null]);
    dispose();
  };
  document.body.appendChild(containerEl);
  const baseMap = new BaseMap({
    themeColor,
    TianDiTuKey,
    container: containerEl,
    zoom: 17,
    center: [28.228304, 112.938882],
    onlyRead: true,
    leafletOptions: {
      zoomAnimation: false,
      fadeAnimation: false,
      markerZoomAnimation: false,
      preferCanvas: true,
      trackResize: false,
      boxZoom: false,
      doubleClickZoom: false,
      dragging: false,
      keyboard: false
    }
  });
  const renderGraphic = () => {
    baseMap.graphicDiff(graphicInfoList);
    baseMap.toGraphicCenter();
  };
  const devicePixelRatio = window.devicePixelRatio;
  let sourceCanvas;
  const generateImg = () => {
    sourceCanvas = sourceCanvas || containerEl.getElementsByTagName("canvas")[0];
    const canvas = document.createElement("canvas");
    canvas.width = width;
    canvas.height = height;
    const canvas2DCtx = canvas.getContext("2d");
    let count = 0;
    const imageList = [];
    const containerList = containerEl.getElementsByClassName("leaflet-tile-container");
    Array.from(containerList).forEach((container) => {
      Array.from(container.children).forEach((el) => {
        imageList.push(el);
      });
    });
    Array.from(imageList).forEach((localImage) => {
      const image = new Image();
      image.crossOrigin = "anonymous";
      image.width = 256 / devicePixelRatio;
      image.height = 256 / devicePixelRatio;
      image.src = localImage.src;
      image.onload = () => {
        const { x: x2, y: y2 } = getElementOffset(localImage);
        canvas2DCtx.drawImage(image, x2, y2);
        count++;
        if (count === imageList.length) {
          const { x: x22, y: y22 } = getElementOffset(sourceCanvas);
          canvas2DCtx == null ? void 0 : canvas2DCtx.drawImage(sourceCanvas, x22, y22, parseInt(sourceCanvas.style.width), parseInt(sourceCanvas.style.height));
          if (options.toBlob) {
            canvas.toBlob((blob) => {
              handleResolve(blob);
            }, "image/jpeg", 1);
          } else {
            const dataUrl = canvas.toDataURL("image/jpeg", 1);
            handleResolve(dataUrl);
          }
        }
      };
    });
  };
  const mapInstance = baseMap.mapInstance;
  let isFirstLoad = true;
  let loadCount = 0;
  mapInstance.eachLayer((layer) => {
    layer.on("load", () => {
      loadCount++;
      const isDone = loadCount === 2;
      if (isDone) {
        if (isFirstLoad) {
          isFirstLoad = false;
          renderGraphic();
        } else {
          generateImg();
        }
        loadCount = 0;
      }
    });
    layer.on("tileerror", () => {
      handleReject(new Error("load tile error"));
    });
  });
  return result;
});
class BaseMap {
  constructor(options) {
    this.drawMap = new Map();
    this.transformState = null;
    if (!options.center) {
      throw new Error("center is required");
    }
    if (!options.zoom) {
      throw new Error("zoom is required");
    }
    this.options = options;
    this.options.closedMinDistance = this.options.closedMinDistance || 5;
    this.layers = new Layers({
      TianDiTuKey: this.options.TianDiTuKey,
      onLoad: this.options.layerOnLoad
    });
    this.eventBind = new EventBind(this.drawMap);
    this.init();
  }
  changeLayerByType(layerType) {
    this.layers.changeLayerByType(this.mapInstance, layerType);
  }
  setCenter(center) {
    this.mapInstance.setView(center);
    this.updatePoiCenter(center);
  }
  setZoom(zoom) {
    this.mapInstance.setZoom(zoom);
  }
  graphicDiff(graphicInfoList) {
    const pathNotEqual = (path1, path2) => path1.length !== path2.length || path1.some((p2, i2) => p2[0] !== path2[i2][0] || p2[1] !== path2[i2][1]);
    const existing = [];
    graphicInfoList.forEach((graphicInfo) => {
      const id = graphicInfo.id;
      const drawInstance = this.drawMap.get(id);
      existing.push(id);
      if (drawInstance) {
        let hasChange = false;
        if (drawInstance.getIsClosed() !== graphicInfo.isClosed) {
          hasChange = true;
          drawInstance.setIsClosed(graphicInfo.isClosed);
        }
        if (pathNotEqual(drawInstance.getPath(), graphicInfo.path)) {
          hasChange = true;
          drawInstance.setPath(graphicInfo.path);
        }
        if (graphicInfo.editorEnable !== void 0 && graphicInfo.editorEnable !== drawInstance.getEditorEnable()) {
          hasChange = true;
          drawInstance.setEditorEnable(graphicInfo.editorEnable);
        }
        if (graphicInfo.themeColor && drawInstance.getColor() !== graphicInfo.themeColor) {
          drawInstance.setColor(graphicInfo.themeColor);
        }
        if (graphicInfo.fillColor && drawInstance.getFillColor() !== graphicInfo.fillColor) {
          drawInstance.setFillColor(graphicInfo.fillColor);
        }
        if (graphicInfo.weight !== void 0 && drawInstance.getWeight() !== graphicInfo.weight) {
          drawInstance.setWeight(graphicInfo.weight);
        }
        if (graphicInfo.title !== void 0 && drawInstance.getTitle() !== graphicInfo.title) {
          drawInstance.setTitle(graphicInfo.title);
        }
        if (hasChange) {
          drawInstance.drawing();
          this.triggerLengthOrAreaUpdate(graphicInfo.id);
        }
      } else {
        const drawInstance2 = new Draw({
          id: graphicInfo.id,
          map: this.mapInstance,
          enableIntersectDetection: this.options.enableIntersectDetection,
          onIntersectStatusChange: () => {
            this.handleIntersectStatusChange(graphicInfo.id);
          },
          onPolygonPathChange: () => {
            this.handlePolygonPathChange(graphicInfo.id);
          },
          onClosed: () => {
            this.handleClosed(graphicInfo.id);
          },
          markerOptions: graphicInfo.markerOptions,
          polylineOptions: graphicInfo.polylineOptions,
          polygonOptions: graphicInfo.polygonOptions,
          titleClassName: graphicInfo.titleClassName,
          onlyShowTitle: graphicInfo.onlyShowTitle
        });
        if (graphicInfo.themeColor || this.options.themeColor) {
          drawInstance2.setColor(graphicInfo.themeColor || this.options.themeColor);
        }
        if (graphicInfo.fillColor) {
          drawInstance2.setFillColor(graphicInfo.fillColor);
        }
        drawInstance2.setEditorEnable(graphicInfo.editorEnable !== void 0 ? graphicInfo.editorEnable : !this.options.onlyRead);
        drawInstance2.setIsClosed(graphicInfo.isClosed);
        drawInstance2.setPath(graphicInfo.path);
        drawInstance2.setTitle(graphicInfo.title);
        if (graphicInfo.weight) {
          drawInstance2.setWeight(graphicInfo.weight);
        }
        drawInstance2.drawing();
        this.drawMap.set(graphicInfo.id, drawInstance2);
      }
    });
    this.eachDrawMap((_2, id) => {
      if (!existing.includes(id)) {
        const draw = this.drawMap.get(id);
        draw == null ? void 0 : draw.destroy();
        this.drawMap.delete(id);
      }
    });
    this.eventBind.bindToNewTarget();
  }
  eachDrawMap(callback) {
    Array.from(this.drawMap.keys()).forEach((id) => {
      const draw = this.drawMap.get(id);
      callback(draw, id);
    });
  }
  forceUpdateLengthAndAreaInfo() {
    this.eachDrawMap((_2, id) => {
      this.triggerLengthOrAreaUpdate(id);
    });
  }
  toGraphicCenter(selectedGraphicId) {
    if (!this.drawMap.size)
      return;
    const llb = new LatLngBounds([]);
    this.eachDrawMap((draw, id) => {
      const p2 = draw.getPath();
      if (p2.length) {
        if (selectedGraphicId !== void 0) {
          if (Array.isArray(selectedGraphicId)) {
            if (selectedGraphicId.includes(id)) {
              llb.extend(p2);
            }
          } else if (selectedGraphicId === id) {
            llb.extend(p2);
          }
        } else {
          llb.extend(p2);
        }
      }
    });
    try {
      const zoom = this.mapInstance.getBoundsZoom(llb);
      const center = llb.getCenter();
      this.mapInstance.setView(center, zoom);
      this.updatePoiCenter([center.lat, center.lng]);
    } catch (e2) {
    }
  }
  destroy() {
    if (this.mapInstance) {
      this.mapInstance.remove();
    }
    if (this.poi) {
      this.poi.destroy();
    }
  }
  getSnapshot(options) {
    return __async(this, null, function* () {
      const graphicInfoList = Array.from(this.drawMap.values()).map((d2) => ({
        id: d2.options.id,
        path: d2.getPath(),
        isClosed: d2.getIsClosed(),
        themeColor: d2.getColor(),
        title: d2.getTitle()
      }));
      return yield getSnapshotByGraphicInfo(__spreadValues({
        graphicInfoList,
        TianDiTuKey: this.options.TianDiTuKey
      }, options));
    });
  }
  on(event, callback) {
    this.eventBind.on(event, callback);
  }
  off(event, callback) {
    this.eventBind.off(event, callback);
  }
  handleTransformGraphics(zoom) {
    if (!this.options.graphicAsIconZoom) {
      return;
    }
    const localState = zoom <= this.options.graphicAsIconZoom;
    if (localState !== this.transformState) {
      this.transformState = localState;
      this.eachDrawMap((draw) => {
        draw.drawingThumbIcon(localState);
      });
    }
  }
  handleDrawing() {
    this.mapInstance.on("click", (e2) => {
      let hasClosed = false;
      this.eachDrawMap((draw, id) => {
        const isClosed = draw.getIsClosed();
        const path = draw.getPath();
        if (!isClosed && path.length >= 3) {
          const firstPath = draw.getPath()[0];
          const firstPoint = this.mapInstance.latLngToContainerPoint(new LatLng(firstPath[0], firstPath[1]));
          const distance2 = firstPoint.distanceTo(this.mapInstance.latLngToContainerPoint(e2.latlng));
          if (distance2 <= this.options.closedMinDistance) {
            hasClosed = true;
            this.options.onPolygonClosed && this.options.onPolygonClosed(id);
          }
        }
      });
      if (!hasClosed) {
        this.options.onMapClick && this.options.onMapClick([e2.latlng.lat, e2.latlng.lng]);
      }
    });
  }
  init() {
    const { container, zoom, maxZoom, center, onlyRead } = this.options;
    const map = L$2.map(container, __spreadValues({
      zoom,
      maxZoom,
      center,
      tap: false,
      layers: this.layers.getLayerByType(LayerType.defaultSatellite),
      zoomControl: false,
      editable: !onlyRead,
      editOptions: {
        isShowSideLength: !!this.options.isShowSideLength
      }
    }, this.options.leafletOptions));
    this.mapInstance = map;
    this.eventBind.setLeafletMapInstance(map);
    if (this.options.onMove) {
      this.eventBind.on("map:move", () => {
        const center2 = map.getCenter();
        const latlng = [center2.lat, center2.lng];
        this.options.onMove(latlng);
      });
    }
    if (this.options.onZoom) {
      this.eventBind.on("map:zoom", () => {
        const center2 = map.getCenter();
        const latlng = [center2.lat, center2.lng];
        const zoom2 = map.getZoom();
        this.options.onZoom(zoom2, latlng);
      });
    }
    if (this.options.onZoomEnd) {
      this.eventBind.on("map:zoomend", () => {
        const zoom2 = map.getZoom();
        this.options.onZoomEnd(zoom2);
        this.handleTransformGraphics(zoom2);
      });
    }
    if (this.options.onMapPolygonClick) {
      this.eventBind.on("polygon:click", ({ id }) => {
        this.options.onMapPolygonClick(id);
      });
    }
    if (this.options.onMapPolygonRightClick) {
      this.eventBind.on("polygon:contextmenu", (event) => {
        this.options.onMapPolygonRightClick(event);
      });
    }
    if (this.options.onTitleClick) {
      this.eventBind.on("title:click", ({ id }) => {
        this.options.onTitleClick(id);
      });
    }
    if (!onlyRead) {
      this.handleDrawing();
    }
    Promise.resolve().then(() => {
      this.options.onMounted && this.options.onMounted();
    });
    this.initPoi();
  }
  initPoi() {
    const { poiOptions, TianDiTuKey, center } = this.options;
    if (poiOptions && poiOptions.container) {
      this.poi = poi;
      poi.create({
        container: poiOptions.container,
        tk: TianDiTuKey,
        center,
        limit: poiOptions.limit,
        onPoiChange: (p2) => {
          poiOptions.onPoiChange && poiOptions.onPoiChange(p2);
        }
      });
    }
  }
  handleClosed(id) {
    if (this.options.onPolygonClosed) {
      this.options.onPolygonClosed(id);
    }
  }
  handleIntersectStatusChange(id) {
    if (!this.options.onIntersectStatusChange)
      return;
    const draw = this.drawMap.get(id);
    this.options.onIntersectStatusChange(id, draw.getIsIntersect());
  }
  handlePolygonPathChange(id) {
    if (!this.options.onPolygonPathChange)
      return;
    const draw = this.drawMap.get(id);
    this.options.onPolygonPathChange(id, draw.getPath());
    this.triggerLengthOrAreaUpdate(id);
  }
  triggerLengthOrAreaUpdate(id) {
    const drawInstance = this.drawMap.get(id);
    this.options.onGraphicLengthOrAreaUpdate && this.options.onGraphicLengthOrAreaUpdate(id, drawInstance.getLength(), drawInstance.getArea());
  }
  updatePoiCenter(center) {
    if (this.poi) {
      this.poi.updateCenter(center);
    }
  }
}
styleInject(css$1);
export { BaseMap, ICON_SIZE, LayerType, ZoomLimit, calculateCenter, clonePath, getAreaByCoords, getGeocodeInfo, getLengthByCoords, getSnapshotByGraphicInfo, latLngListToLngLatList, latLngToLngLat, lngLatListToLatLngList, lngLatToLatLng, queryPoiListByKeyword, squareMeterToMu, toClosedPath, toNotClosedPath, toTwoDecimalPlacesNumber };
